import moment from "moment";
import { post } from "./post";

export const avatarImg = "/images/avatar.svg";

export const LIMIT = 25;

export const userData = JSON.parse(localStorage.getItem("userData"));
export const selectedOptic = JSON.parse(localStorage.getItem("selectedOptic"));
const formattedCurrentDate = moment().format("YYYY-MM-DD HH:mm:ss");
const currentDate = moment();

export const isLoggedIn = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return userData !== null && userData.token !== "";
};

export const disconnect = async () => {
  await post("Logout.php", {
    token: userData.token,
  });
  localStorage.removeItem("userData");
  localStorage.removeItem("selectedOptic");
  localStorage.removeItem("lastUser");
  window.location = "/";
};

export const focusElement = (index) => {
  const inputElement = document.querySelector(`[tabindex="${index}"]`);

  if (inputElement) {
    inputElement.focus();
    inputElement.select();
  }
};

export const getTodayString = () => {
  const now = new Date();
  return new Date(now.getTime() - now.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
};

export const inputOnEnter = (evt) => {
  if (evt.keyCode === 13) {
    // No permitir navegación si hay un popup activo
    const popupActive = document.querySelector(".info-popup");
    if (popupActive) {
      return;
    }

    let inputsAndTextareas = document.querySelectorAll("input, textarea");

    const inputsAndTextareasArray = Array.from(inputsAndTextareas).filter(
      (el) => {
        // Filtrar elementos ocultos, disabled o sin tabIndex
        return el.tabIndex > 0 && !el.disabled && el.offsetParent !== null; // verifica que sea visible
      },
    );

    inputsAndTextareasArray.sort((a, b) => a.tabIndex - b.tabIndex);

    let nextElement = inputsAndTextareasArray.find(
      (el) => el.tabIndex > evt.target.tabIndex,
    );

    if (nextElement) {
      nextElement.focus();
      // Solo llamar select() si es un input de texto o textarea
      if (
        nextElement.type !== "radio" &&
        nextElement.type !== "checkbox" &&
        typeof nextElement.select === "function"
      ) {
        nextElement.select();
      }
    }
  }
};

export const areObjectsEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;
  if (!obj1 || !obj2) return false;

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    const val1 = obj1[key];
    const val2 = obj2[key];

    if (typeof val1 === "object" && typeof val2 === "object") {
      if (!areObjectsEqual(val1, val2)) {
        return false;
      }
    } else {
      if (val1 !== val2) {
        return false;
      }
    }
  }

  return true;
};

export function calculateSectionTotal(pvp, discountPercent) {
  const discount = parseFloat(pvp) * (parseFloat(discountPercent) / 100);
  const total = pvp - discount;
  return parseFloat(total.toFixed(2));
}

export const checkOfferActive = (start, end) => {
  const now = new Date();

  const startDate = new Date(start.replace(" ", "T"));
  const endDate = new Date(end.replace(" ", "T"));

  const isActive = now >= startDate && now <= endDate;
  return isActive;
};

export const checkOfferPrice = (data) => {
  const { fechaOfertaInicio, fechaOfertaFin, pvpOferta, pvp } = data;

  if (fechaOfertaInicio && fechaOfertaFin && pvpOferta !== "") {
    return checkOfferActive(fechaOfertaInicio, fechaOfertaFin)
      ? pvpOferta
      : pvp;
  }
  return pvp;
};

// round: si es false, el descuento y el total calculados se devuelven sin
// redondear (p. ej. en la ficha de gafas, donde descuentos y precios se
// guardan como float y solo se muestran redondeados en los inputs).
export const calculateDiscountFromTotal = (data) => {
  const { pvp, dto, dtoMax, pack = 1, round = true } = data;
  const round2 = (value) => (round ? Math.round(value * 100) / 100 : value);
  const total = parseFloat(data.total);

  if (isNaN(total)) {
    return {
      total: pvp * pack,
      dto: 0,
      error: "El valor introducido no es un número válido.",
    };
  }

  const unitTotal = total / pack;

  // Evitar división por cero
  if (pvp === 0) {
    return {
      total: total,
      dto: 0,
      error: "",
    };
  }

  // No permitir que el total por unidad supere el pvp
  if (unitTotal > pvp) {
    const correctedUnitTotal = round2(pvp * (1 - dto / 100));
    return {
      total: round2(correctedUnitTotal * pack),
      dto,
      error:
        "El total no puede ser mayor que el PVP. Se ha aplicado el descuento original.",
    };
  }

  // Calcular descuento sobre el precio unitario
  const calculatedDto = (1 - unitTotal / pvp) * 100;

  const maxDto =
    dtoMax === "" || dtoMax === undefined ? null : parseFloat(dtoMax);
  if (maxDto !== null && !isNaN(maxDto) && calculatedDto > maxDto) {
    const correctedUnitTotal = round2(pvp * (1 - dto / 100));
    return {
      total: round2(correctedUnitTotal * pack),
      dto,
      error: `El descuento supera el máximo permitido del ${maxDto} %. Se ha aplicado el descuento original.`,
    };
  }

  return {
    total: round2(total),
    dto: round2(calculatedDto),
    error: "",
  };
};

export const recalcularDesdePCN = (nuevoPCN, data) => {
  const newData = structuredClone(data);
  newData.pcn = parseFloat(nuevoPCN);

  if (data.pcb > 0) {
    newData.porcDescuento = Number(
      (((data.pcb - parseFloat(nuevoPCN)) / data.pcb) * 100).toFixed(2),
    );
  } else {
    newData.porcDescuento = 0;
  }

  newData.iva = Number(parseFloat(nuevoPCN) * (data.porcIVA / 100));
  newData.re = Number(parseFloat(nuevoPCN) * (data.porcRE / 100));
  newData.pcu = Number(
    (parseFloat(nuevoPCN) + newData.iva + newData.re).toFixed(2),
  );
  newData.total = Number((newData.pcu * newData.stock).toFixed(2));
  return newData;
};

export const recalcularDesdePCB = (nuevoPCB, data) => {
  const newData = structuredClone(data);
  newData.pcb = nuevoPCB;
  newData.pcn = Number(nuevoPCB * (1 - data.porcDescuento / 100));
  newData.iva = Number(newData.pcn * (data.porcIVA / 100));
  newData.re = Number(newData.pcn * (data.porcRE / 100));
  newData.pcu = Number((newData.pcn + newData.iva + newData.re).toFixed(2));
  newData.total = Number((newData.pcu * newData.stock).toFixed(2));
  return newData;
};

export const recalcularDesdePorcDescuento = (nuevoPorcDescuento, data) => {
  const newData = structuredClone(data);
  newData.porcDescuento = nuevoPorcDescuento;
  newData.pcn = Number(newData.pcb * (1 - newData.porcDescuento / 100));
  newData.iva = Number(newData.pcn * (data.porcIVA / 100));
  newData.re = Number(newData.pcn * (data.porcRE / 100));
  newData.pcu = Number((newData.pcn + newData.iva + newData.re).toFixed(2));
  newData.total = Number((newData.pcu * newData.stock).toFixed(2));
  return newData;
};

export const recalcularDesdePorcIVA = (nuevoPorcIVA, data) => {
  const newData = structuredClone(data);
  newData.porcIVA = nuevoPorcIVA;
  newData.iva = Number(newData.pcn * (nuevoPorcIVA / 100));
  newData.re = Number(newData.pcn * (data.porcRE / 100));
  newData.pcu = Number((newData.pcn + newData.iva + newData.re).toFixed(2));
  newData.total = Number((newData.pcu * newData.stock).toFixed(2));
  return newData;
};

export const loginOptions = [
  {
    id: "esp",
    img: "/images/flags/espana.svg",
    text: "CASTELLANO",
  },
  {
    id: "fra",
    img: "/images/flags/francia.svg",
    text: "FRANCÉS",
  },
  {
    id: "ale",
    img: "/images/flags/alemania.svg",
    text: "ALEMÁN",
  },
  {
    id: "por",
    img: "/images/flags/portugal.svg",
    text: "PORTUGUÉS",
  },
];

export const sexOptions = [
  {
    id: "",
    text: "",
  },
  {
    id: "HOMBRE",
    text: "HOMBRE",
  },
  {
    id: "MUJER",
    text: "MUJER",
  },
];

export const rangeOptions = [
  { id: "", text: "" },
  { id: "ALTA", text: "ALTA" },
  { id: "MEDIA", text: "MEDIA" },
  { id: "BAJA", text: "BAJA" },
];

export const provinceOptions = [
  {
    id: "",
    text: "",
  },
  {
    id: "ÁLAVA",
    text: "ÁLAVA",
  },
  {
    id: "ALBACETE",
    text: "ALBACETE",
  },
  {
    id: "ALICANTE",
    text: "ALICANTE",
  },
  {
    id: "ALMERÍA",
    text: "ALMERÍA",
  },
  {
    id: "ANDORRA",
    text: "ANDORRA",
  },
  {
    id: "ASTURIAS",
    text: "ASTURIAS",
  },
  {
    id: "ÁVILA",
    text: "ÁVILA",
  },
  {
    id: "BADAJOZ",
    text: "BADAJOZ",
  },
  {
    id: "BARCELONA",
    text: "BARCELONA",
  },
  {
    id: "BIZKAIA",
    text: "BIZKAIA",
  },
  {
    id: "BURGOS",
    text: "BURGOS",
  },
  {
    id: "CÁCERES",
    text: "CÁCERES",
  },
  {
    id: "CÁDIZ",
    text: "CÁDIZ",
  },
  {
    id: "CANTABRIA",
    text: "CANTABRIA",
  },
  {
    id: "CASTELLÓN",
    text: "CASTELLÓN",
  },
  {
    id: "CEUTA",
    text: "CEUTA",
  },
  {
    id: "CIUDAD REAL",
    text: "CIUDAD REAL",
  },
  {
    id: "CÓRDOBA",
    text: "CÓRDOBA",
  },
  {
    id: "CORUÑA",
    text: "CORUÑA",
  },
  {
    id: "CUENCA",
    text: "CUENCA",
  },
  {
    id: "GIPUZKOA",
    text: "GIPUZKOA",
  },
  {
    id: "GIRONA",
    text: "GIRONA",
  },
  {
    id: "GRANADA",
    text: "GRANADA",
  },
  {
    id: "GUADALAJARA",
    text: "GUADALAJARA",
  },
  {
    id: "HUELVA",
    text: "HUELVA",
  },
  {
    id: "HUESCA",
    text: "HUESCA",
  },
  {
    id: "ILLES BALEARS",
    text: "ILLES BALEARS",
  },
  {
    id: "JAEN",
    text: "JAEN",
  },
  {
    id: "LA RIOJA",
    text: "LA RIOJA",
  },
  {
    id: "LAS PALMAS",
    text: "LAS PALMAS",
  },
  {
    id: "LEÓN",
    text: "LEÓN",
  },
  {
    id: "LLEIDA",
    text: "LLEIDA",
  },
  {
    id: "LUGO",
    text: "LUGO",
  },
  {
    id: "MADRID",
    text: "MADRID",
  },
  {
    id: "MÁLAGA",
    text: "MÁLAGA",
  },
  {
    id: "MELILLA",
    text: "MELILLA",
  },
  {
    id: "MURCIA",
    text: "MURCIA",
  },
  {
    id: "NAVARRA",
    text: "NAVARRA",
  },
  {
    id: "OURENSE",
    text: "OURENSE",
  },
  {
    id: "PALENCIA",
    text: "PALENCIA",
  },
  {
    id: "PONTEVEDRA",
    text: "PONTEVEDRA",
  },
  {
    id: "S.C. TENERIFE",
    text: "S.C. TENERIFE",
  },
  {
    id: "SALAMANCA",
    text: "SALAMANCA",
  },
  {
    id: "SEGOVIA",
    text: "SEGOVIA",
  },
  {
    id: "SEVILLA",
    text: "SEVILLA",
  },
  {
    id: "SORIA",
    text: "SORIA",
  },
  {
    id: "TARRAGONA",
    text: "TARRAGONA",
  },
  {
    id: "TERUEL",
    text: "TERUEL",
  },
  {
    id: "TOLEDO",
    text: "TOLEDO",
  },
  {
    id: "VALENCIA",
    text: "VALENCIA",
  },
  {
    id: "VALLADOLID",
    text: "VALLADOLID",
  },
  {
    id: "ZAMORA",
    text: "ZAMORA",
  },
  {
    id: "ZARAGOZA",
    text: "ZARAGOZA",
  },
];

export const svgIcons = {
  whatsapp: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <g>
        <path
          d="M435.922 74.352C387.824 26.434 323.84.027 255.742 0 187.797 0 123.711 26.383 75.297 74.29 26.797 122.276.063 186.05 0 253.628v.125c.008 40.902 10.754 82.164 31.152 119.828L.7 512l140.012-31.848c35.46 17.871 75.027 27.293 114.934 27.309h.101c67.934 0 132.02-26.387 180.441-74.297 48.543-48.027 75.29-111.719 75.32-179.34.02-67.144-26.82-130.883-75.585-179.472zM255.742 467.5h-.09c-35.832-.016-71.336-9.012-102.668-26.023l-6.62-3.594-93.102 21.176 20.222-91.907-3.898-6.722C50.203 327.004 39.96 290.105 39.96 253.71c.074-117.8 96.863-213.75 215.773-213.75 57.446.024 111.422 22.294 151.985 62.7 41.176 41.031 63.844 94.711 63.824 151.153-.047 117.828-96.856 213.687-215.8 213.687zm0 0"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M186.152 141.863h-11.21c-3.903 0-10.239 1.461-15.598 7.293-5.364 5.836-20.477 19.942-20.477 48.63s20.965 56.405 23.887 60.3c2.926 3.89 40.469 64.64 99.93 88.012 49.418 19.422 59.476 15.558 70.199 14.586 10.726-.97 34.613-14.102 39.488-27.715s4.875-25.285 3.414-27.723c-1.465-2.43-5.367-3.887-11.215-6.8-5.851-2.919-34.523-17.262-39.886-19.212-5.364-1.941-9.262-2.914-13.164 2.926-3.903 5.828-15.391 19.313-18.805 23.203-3.41 3.895-6.824 4.383-12.676 1.465-5.852-2.926-24.5-9.191-46.848-29.05-17.394-15.458-29.464-35.169-32.879-41.005-3.41-5.832-.363-8.988 2.57-11.898 2.63-2.61 6.18-6.18 9.106-9.582 2.922-3.406 3.754-5.836 5.707-9.727 1.95-3.89.973-7.296-.488-10.21-1.465-2.919-12.691-31.75-17.895-43.282h.004c-4.382-9.71-8.996-10.039-13.164-10.21zm0 0"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  ),
  schedule: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      viewBox="0 0 24 24"
    >
      <g>
        <path
          d="M11 22H6c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h1V3c0-.6.4-1 1-1s1 .4 1 1v1h6V3c0-.6.4-1 1-1s1 .4 1 1v1h1c1.7 0 3 1.3 3 3v4.8c0 .6-.4 1-1 1s-1-.4-1-1V11H5v8c0 .6.4 1 1 1h5c.6 0 1 .4 1 1s-.4 1-1 1zM5 9h14V7c0-.6-.4-1-1-1h-1v1c0 .6-.4 1-1 1s-1-.4-1-1V6H9v1c0 .6-.4 1-1 1s-1-.4-1-1V6H6c-.6 0-1 .4-1 1z"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M16 22c-.3 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l1.3 1.3 4.3-4.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5 5c-.2.2-.4.3-.7.3z"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  ),
  email: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 512 512"
    >
      <g>
        <path
          d="M505.605 246.395 450 190.785V55c0-30.328-24.672-55-55-55H115C84.672 0 60 24.672 60 55v135.785c-1.625 1.625-54.746 54.742-55.672 55.68A15.123 15.123 0 0 0 0 257v210c0 24.813 20.188 45 45 45h420c24.813 0 45-20.188 45-45V257c0-4.059-1.71-7.922-4.395-10.605zm-35.93 6.496L450 262.73v-29.516zM115 30h280c13.785 0 25 11.215 25 25v222.73l-165 82.5-165-82.5V55c0-13.785 11.215-25 25-25zM60 262.73l-19.676-9.84L60 233.216zM465 482H45c-8.27 0-15-6.73-15-15V281.27l218.293 109.148a15.008 15.008 0 0 0 13.414 0L480 281.27V467c0 8.27-6.73 15-15 15zm0 0"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M295.105 295.45c7.872-2.587 12.153-11.063 9.567-18.934s-11.063-12.153-18.934-9.567C222.957 287.58 165.031 241.7 165.031 182c0-49.625 40.36-90 89.969-90 49.605 0 89.965 40.375 89.965 90 0 37-27.406 39.09-29.809 4.621a15.63 15.63 0 0 0-.23-1.73C316.566 150.535 289.07 122 255 122c-33.086 0-60 26.914-60 60 0 53.297 64.754 80.094 102.426 42.387 25.008 32.61 77.539 17.582 77.539-42.387 0-66.168-53.817-120-119.965-120-66.152 0-119.969 53.832-119.969 120 .004 79.695 77.457 140.598 160.074 113.45zM255 212c-16.543 0-30-13.457-30-30s13.457-30 30-30 30 13.457 30 30-13.457 30-30 30zm0 0"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  ),
  sms: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      viewBox="0 0 32 32"
    >
      <g transform="matrix(1.2100000000000004,0,0,1.2100000000000004,-3.3600000000000065,-3.3599907875060993)">
        <path
          d="M25 3H7a4 4 0 0 0-4 4v14.2a4 4 0 0 0 4 4h4.52l2.135 2.671a3 3 0 0 0 4.69 0L20.48 25.2H25a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4zm2 18.2a2 2 0 0 1-2 2h-5a1 1 0 0 0-.781.376l-2.437 3.045a1.032 1.032 0 0 1-1.564 0l-2.437-3.045A1 1 0 0 0 12 23.2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2zM24 10a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2h14a1 1 0 0 1 1 1zm0 4a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2h14a1 1 0 0 1 1 1zm0 4a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2h14a1 1 0 0 1 1 1z"
          data-name="Layer 1"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  ),
  user: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="user-blue 1">
        <path
          id="Vector"
          d="M90.625 93.7031H9.39453V88.832C9.39453 71.0312 23.5937 56.5508 41.0352 56.5508H58.9492C76.3984 56.5508 90.5898 71.0312 90.5898 88.832L90.625 93.7031ZM14.168 88.9297H85.832V88.832C85.832 73.6641 73.7734 61.3242 58.957 61.3242H41.043C26.2266 61.3242 14.168 73.6641 14.168 88.832V88.9297ZM50 48.0195C38.7227 48.0195 29.5469 38.6445 29.5469 27.1562C29.5469 15.668 38.7227 6.29688 50 6.29688C61.2773 6.29688 70.4531 15.6719 70.4531 27.1562C70.4531 38.6406 61.2773 48.0195 50 48.0195ZM50 11.0703C41.3555 11.0703 34.3203 18.2852 34.3203 27.1562C34.3203 36.0273 41.3516 43.2422 50 43.2422C58.6484 43.2422 65.6797 36.0273 65.6797 27.1562C65.6797 18.2852 58.6445 11.0703 50 11.0703Z"
          fill="#4ABEFF"
        />
      </g>
    </svg>
  ),
  calendar: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="calendar-blue 1">
        <g id="Group">
          <path
            id="Vector"
            d="M51.5235 76.8359C52.7344 76.0547 53.086 74.4141 52.2657 73.2031C52.1485 73.0469 52.0313 72.8906 51.9141 72.7734C51.5235 72.3828 51.0547 72.1484 50.5469 72.0312C49.4922 71.8359 48.3985 72.2656 47.7735 73.1641C47.0704 74.2187 47.1876 75.625 48.086 76.4844C48.9844 77.3828 50.4297 77.5 51.5235 76.8359Z"
            fill="#4ABEFF"
          />
          <path
            id="Vector_2"
            d="M51.9141 56.3281C51.5234 55.9375 51.0547 55.7031 50.5469 55.5859C50.3906 55.5469 50.1953 55.5469 50 55.5469C49.6484 55.5469 49.2969 55.625 48.9453 55.7422C48.4375 55.9375 48.0469 56.2891 47.7344 56.7188C47.4219 57.1484 47.2656 57.6563 47.2656 58.2031C47.2656 58.9063 47.5391 59.5703 48.0469 60.0781C48.9844 60.9375 50.3906 61.0938 51.4844 60.4297C51.9141 60.1563 52.2656 59.7266 52.4609 59.2188C52.8906 58.2031 52.6562 57.0703 51.9141 56.3281Z"
            fill="#4ABEFF"
          />
          <path
            id="Vector_3"
            d="M31.1327 56.3281C30.742 55.9375 30.2733 55.7031 29.7655 55.5859C29.6092 55.5469 29.4139 55.5469 29.2186 55.5469C28.867 55.5469 28.5155 55.625 28.1639 55.7422C27.6561 55.9375 27.2655 56.2891 26.953 56.7188C26.2499 57.7734 26.367 59.1797 27.3045 60.0391C28.242 60.8984 29.6483 61.0547 30.742 60.3906C31.1717 60.1172 31.5233 59.6875 31.7186 59.1797C31.9139 58.7109 31.953 58.1641 31.8749 57.6563C31.7577 57.1875 31.5233 56.6797 31.1327 56.3281Z"
            fill="#4ABEFF"
          />
          <path
            id="Vector_4"
            d="M30.742 76.8359C31.1717 76.5625 31.5233 76.1328 31.7186 75.6641C32.1092 74.6875 31.9139 73.5547 31.1327 72.7734C30.742 72.3828 30.2733 72.1484 29.7655 72.0312C29.2577 71.9141 28.7108 71.9922 28.203 72.1875C27.6952 72.3828 27.3045 72.7344 26.992 73.1641C26.2889 74.2188 26.4061 75.625 27.3436 76.4844C28.242 77.3828 29.6483 77.5 30.742 76.8359Z"
            fill="#4ABEFF"
          />
          <path
            id="Vector_5"
            d="M72.2656 76.8359C72.6953 76.5625 73.0469 76.1328 73.2422 75.6641C73.4375 75.1953 73.5156 74.6484 73.3984 74.1406C73.2812 73.6328 73.0469 73.1641 72.6563 72.7734C72.2656 72.3828 71.7969 72.1484 71.2891 72.0312C70.2344 71.8359 69.1406 72.2656 68.5156 73.1641C68.2031 73.5937 68.0469 74.1016 68.0469 74.6484C68.0469 75.3516 68.3203 76.0156 68.8281 76.5234C69.7656 77.3828 71.1719 77.5 72.2656 76.8359Z"
            fill="#4ABEFF"
          />
          <path
            id="Vector_6"
            d="M72.6953 56.3281C72.3047 55.9375 71.8359 55.7031 71.3281 55.5859C71.1719 55.5469 70.9766 55.5469 70.7812 55.5469C70.4297 55.5469 70.0781 55.625 69.7656 55.7422C69.2578 55.9375 68.8672 56.2891 68.5547 56.7188C68.2422 57.1484 68.0859 57.6563 68.0859 58.2031C68.0859 58.9063 68.3594 59.5703 68.8672 60.0781C69.8047 60.9375 71.2109 61.0938 72.3047 60.4297C72.7344 60.1563 73.0859 59.7266 73.2813 59.2188C73.4766 58.75 73.5547 58.2031 73.4375 57.6953C73.3203 57.1875 73.0469 56.6797 72.6953 56.3281Z"
            fill="#4ABEFF"
          />
          <path
            id="Vector_7"
            d="M30.8594 7.30469C29.9219 6.44531 28.5156 6.44531 27.5781 7.30469C27.1484 7.73438 26.9141 8.28125 26.9141 8.90625V14.8828H20.9375C18.125 14.8828 15.4297 15.9766 13.4375 17.9687C11.4453 19.9219 10.3125 22.5781 10.3516 25.3516V82.8516C10.3516 85.625 11.4453 88.3203 13.4375 90.2734C15.4297 92.2656 18.125 93.3594 20.9375 93.3594H79.1016C81.9141 93.3594 84.6094 92.2656 86.6016 90.2734C88.5938 88.3203 89.7266 85.625 89.6875 82.8516V25.3516C89.6875 22.5781 88.5547 19.8828 86.6016 17.9687C84.6094 15.9766 81.9141 14.8828 79.1016 14.8828H73.0859V8.90625C73.0859 8.32031 72.8516 7.73438 72.4219 7.30469C71.4844 6.44531 70.0781 6.44531 69.1406 7.30469C68.7109 7.73438 68.4766 8.28125 68.4766 8.90625V14.8828H31.5234V8.90625C31.5234 8.32031 31.2891 7.73438 30.8594 7.30469ZM85.0781 82.8516C85.0781 84.4531 84.4531 85.9766 83.3203 87.0703C82.1875 88.2031 80.6641 88.8281 79.0625 88.7891H20.9375C19.3359 88.7891 17.8125 88.1641 16.7188 87.0703C15.5859 85.9375 14.9609 84.4531 14.9609 82.8516V44.0234H85.1172V82.8516H85.0781ZM68.4766 19.375V25.3516C68.4766 25.9375 68.7109 26.5234 69.1406 26.9531C70.0781 27.8125 71.4844 27.8125 72.4219 26.9531C72.8516 26.5234 73.0859 25.9766 73.0859 25.3516V19.375H79.1016C80.7031 19.375 82.2266 20 83.3594 21.1328C84.4922 22.2266 85.1172 23.75 85.1172 25.3516V39.5312H14.9219V25.3516C14.9219 23.75 15.5469 22.2266 16.6797 21.1328C17.8125 20 19.3359 19.375 20.8984 19.375H26.9141V25.3125C26.9141 25.8984 27.1484 26.4844 27.5781 26.9141C28.5156 27.7734 29.9219 27.7734 30.8594 26.9141C31.2891 26.4844 31.5234 25.9375 31.5234 25.3125V19.375H68.4766Z"
            fill="#4ABEFF"
          />
        </g>
      </g>
    </svg>
  ),
  bill: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="doc-blue 1">
        <path
          id="Vector"
          d="M24.2382 72.2969C24.4372 72.497 24.674 72.6557 24.9349 72.7637C25.1957 72.8716 25.4754 72.9267 25.7577 72.9258H39.6093C39.891 72.9266 40.17 72.8715 40.4302 72.7635C40.6904 72.6556 40.9266 72.4969 41.1249 72.2969C41.4245 71.997 41.6285 71.615 41.7111 71.1992C41.7937 70.7834 41.7513 70.3525 41.5891 69.9608C41.4269 69.5691 41.1523 69.2343 40.7999 68.9986C40.4475 68.763 40.0332 68.637 39.6093 68.6367H25.7577C25.3335 68.6363 24.9186 68.7616 24.5656 68.997C24.2126 69.2324 23.9374 69.5672 23.7747 69.959C23.6121 70.3508 23.5693 70.7821 23.6518 71.1982C23.7343 71.6144 23.9383 71.9967 24.2382 72.2969Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_2"
          d="M24.2422 51.5156C24.6448 51.9168 25.1895 52.1428 25.7579 52.1445H53.4649C54.0347 52.1445 54.5812 51.9182 54.9841 51.5153C55.387 51.1124 55.6133 50.5659 55.6133 49.9961C55.6133 49.4263 55.387 48.8798 54.9841 48.4769C54.5812 48.074 54.0347 47.8477 53.4649 47.8477H25.7579C25.1895 47.8494 24.6448 48.0754 24.2422 48.4766C24.0429 48.6754 23.8847 48.9116 23.7768 49.1717C23.6688 49.4318 23.6133 49.7106 23.6133 49.9922C23.6133 50.2738 23.6688 50.5526 23.7768 50.8127C23.8847 51.0727 24.0429 51.309 24.2422 51.5078V51.5156Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_3"
          d="M54.9803 27.7031C54.7818 27.5032 54.5456 27.3447 54.2855 27.2368C54.0253 27.1288 53.7463 27.0736 53.4646 27.0742H25.7576C25.1892 27.0759 24.6446 27.3019 24.242 27.7031C23.944 28.004 23.7416 28.3862 23.6602 28.8017C23.5788 29.2172 23.622 29.6476 23.7843 30.0386C23.9467 30.4297 24.221 30.7641 24.5727 30.9997C24.9245 31.2354 25.3381 31.3619 25.7615 31.3633H53.4685C53.8925 31.363 54.3068 31.237 54.6592 31.0014C55.0115 30.7657 55.2862 30.4309 55.4483 30.0392C55.6105 29.6476 55.653 29.2166 55.5704 28.8008C55.4878 28.385 55.2838 28.003 54.9842 27.7031H54.9803Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_4"
          d="M6.29688 79.4414C6.29636 81.3147 6.66503 83.1698 7.38181 84.9006C8.09859 86.6314 9.14943 88.204 10.4743 89.5285C11.7991 90.853 13.372 91.9034 15.103 92.6197C16.834 93.336 18.6892 93.7041 20.5625 93.7031H79.4414C81.3144 93.7036 83.1692 93.3351 84.8997 92.6186C86.6303 91.902 88.2027 90.8515 89.5271 89.5271C90.8515 88.2027 91.902 86.6303 92.6186 84.8997C93.3351 83.1692 93.7036 81.3144 93.7031 79.4414V61.7187H72.9258V16.2305C72.9263 14.9255 72.6696 13.6332 72.1703 12.4275C71.671 11.2219 70.939 10.1264 70.0161 9.20383C69.0931 8.28126 67.9974 7.54966 66.7915 7.05086C65.5856 6.55206 64.2932 6.29585 62.9883 6.29688H16.2305C14.9258 6.29636 13.6339 6.55295 12.4284 7.05198C11.223 7.55101 10.1277 8.28269 9.20521 9.20522C8.28269 10.1277 7.55101 11.223 7.05198 12.4284C6.55295 13.6339 6.29636 14.9258 6.29688 16.2305V79.4414ZM72.9258 66.0156H89.418V79.4609C89.418 82.1069 88.3669 84.6445 86.4959 86.5154C84.6249 88.3864 82.0873 89.4375 79.4414 89.4375H72.9258V66.0156ZM10.582 16.2305C10.5841 14.733 11.1799 13.2975 12.2387 12.2387C13.2975 11.1799 14.733 10.5841 16.2305 10.582H62.9883C64.4857 10.5841 65.9212 11.1799 66.98 12.2387C68.0389 13.2975 68.6347 14.733 68.6367 16.2305V89.418H20.5625C19.252 89.4185 17.9543 89.1608 16.7434 88.6597C15.5326 88.1585 14.4323 87.4237 13.5055 86.4973C12.5787 85.5708 11.8434 84.4708 11.3418 83.2602C10.8402 82.0495 10.582 80.7519 10.582 79.4414V16.2305Z"
          fill="#4ABEFF"
        />
      </g>
    </svg>
  ),
  box: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="box-blue 1">
        <path
          id="Vector"
          d="M93.3594 76.7187C94.3498 75.2804 94.8784 73.5745 94.875 71.8281V28.1641C94.8749 26.4193 94.3464 24.7155 93.359 23.277C92.3717 21.8385 90.9718 20.7328 89.3438 20.1055L56.6406 7.53125C52.3657 5.88959 47.6343 5.88959 43.3594 7.53125L10.6602 20.1055C9.03127 20.7325 7.63033 21.8379 6.64166 23.2763C5.65299 24.7147 5.12289 26.4187 5.12109 28.1641V71.8281C5.12126 73.5739 5.65072 75.2786 6.6396 76.7173C7.62849 78.156 9.03033 79.2611 10.6602 79.8867L43.3594 92.4688C47.6338 94.113 52.3662 94.113 56.6406 92.4688L89.3398 79.8867C90.9703 79.2635 92.3724 78.1585 93.3594 76.7187ZM44.8203 11.3281C47.5841 10.267 50.6071 10.0802 53.4805 10.793V10.668L89.1445 24.3984L73.0156 31.3203L72.543 31.1406L32.6406 16.0352L44.8203 11.3281ZM47.9453 89.5391L46.3828 89.1484C45.8526 89.0111 45.3309 88.8429 44.8203 88.6445L12.1094 76.0742C11.2511 75.7448 10.5132 75.1624 9.99349 74.4041C9.47377 73.6458 9.19677 72.7474 9.19922 71.8281V28.1523L47.9453 44.7617V89.5391ZM49.5078 40.9648L10.8555 24.4102L26.9102 18.2305L67.6016 33.6406L50 41.1914L49.5078 40.9648ZM55.1797 88.6719C54.6694 88.8709 54.1476 89.0392 53.6172 89.1758L52.0547 89.5664V44.7617L90.8008 28.1445V71.8359C90.8027 72.7551 90.5255 73.6532 90.0058 74.4114C89.4862 75.1696 88.7486 75.7522 87.8906 76.082L55.1797 88.6719Z"
          fill="#4ABEFF"
        />
      </g>
    </svg>
  ),
  crm: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="crm-blue 1">
        <path
          id="Vector"
          d="M49.9999 37.9414C49.4033 37.9412 48.8201 38.118 48.3241 38.4493C47.828 38.7807 47.4413 39.2517 47.213 39.8029C46.9847 40.354 46.925 40.9605 47.0414 41.5456C47.1578 42.1307 47.4452 42.6681 47.8671 43.0898C48.4423 43.6372 49.2059 43.9425 49.9999 43.9425C50.7939 43.9425 51.5576 43.6372 52.1327 43.0898C52.5546 42.6681 52.842 42.1307 52.9584 41.5456C53.0749 40.9605 53.0151 40.354 52.7868 39.8029C52.5585 39.2517 52.1718 38.7807 51.6758 38.4493C51.1797 38.118 50.5965 37.9412 49.9999 37.9414Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_2"
          d="M52.1328 58.9141C52.5544 58.4923 52.8415 57.9549 52.9578 57.37C53.074 56.7851 53.0142 56.1788 52.786 55.6278C52.5577 55.0769 52.1712 54.606 51.6753 54.2746C51.1794 53.9433 50.5964 53.7665 50 53.7665C49.4036 53.7665 48.8206 53.9433 48.3247 54.2746C47.8289 54.606 47.4423 55.0769 47.214 55.6278C46.9858 56.1788 46.926 56.7851 47.0422 57.37C47.1585 57.9549 47.4456 58.4923 47.8672 58.9141C48.4424 59.4615 49.206 59.7667 50 59.7667C50.794 59.7667 51.5576 59.4615 52.1328 58.9141Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_3"
          d="M50.0001 22.1211C49.4035 22.1198 48.8199 22.2958 48.3235 22.6266C47.827 22.9575 47.44 23.4283 47.2115 23.9794C46.9831 24.5305 46.9234 25.1371 47.0402 25.7221C47.1569 26.3072 47.4448 26.8444 47.8673 27.2656C48.4424 27.813 49.2061 28.1183 50.0001 28.1183C50.7941 28.1183 51.5577 27.813 52.1329 27.2656C52.5554 26.8444 52.8433 26.3072 52.96 25.7221C53.0767 25.1371 53.0171 24.5305 52.7886 23.9794C52.5601 23.4283 52.1731 22.9575 51.6767 22.6266C51.1802 22.2958 50.5967 22.1198 50.0001 22.1211Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_4"
          d="M67.9687 58.9141C68.3904 58.4923 68.6775 57.9549 68.7937 57.37C68.91 56.7851 68.8502 56.1788 68.6219 55.6278C68.3936 55.0769 68.0071 54.606 67.5112 54.2746C67.0153 53.9433 66.4323 53.7665 65.8359 53.7665C65.2396 53.7665 64.6566 53.9433 64.1607 54.2746C63.6648 54.606 63.2783 55.0769 63.05 55.6278C62.8217 56.1788 62.7619 56.7851 62.8782 57.37C62.9944 57.9549 63.2815 58.4923 63.7031 58.9141C64.2783 59.4615 65.0419 59.7667 65.8359 59.7667C66.63 59.7667 67.3936 59.4615 67.9687 58.9141Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_5"
          d="M66.3008 8.83204C65.4962 8.02264 64.5385 7.38161 63.4835 6.94634C62.4286 6.51107 61.2975 6.29029 60.1563 6.29688H24.0039C22.8658 6.29637 21.7387 6.52009 20.6871 6.95527C19.6355 7.39045 18.6799 8.02856 17.875 8.83314C17.07 9.63773 16.4315 10.593 15.9958 11.6444C15.5602 12.6959 15.3359 13.8228 15.3359 14.9609V91.8203C15.3383 92.32 15.5376 92.7986 15.8906 93.1524C16.0652 93.3277 16.2728 93.4666 16.5015 93.5612C16.7301 93.6557 16.9752 93.704 17.2227 93.7031H82.7774C83.0248 93.704 83.2699 93.6557 83.4985 93.5612C83.7272 93.4666 83.9348 93.3277 84.1094 93.1524C84.4624 92.7986 84.6617 92.32 84.6641 91.8203V48.8711C84.6641 46.5722 83.7508 44.3675 82.1253 42.7419C80.4997 41.1164 78.295 40.2031 75.9961 40.2031H68.8398V14.9609C68.8439 13.8221 68.6215 12.6938 68.1856 11.6416C67.7497 10.5894 67.109 9.63442 66.3008 8.83204ZM48.1172 89.9375H34.9297V75.6211H48.1172V89.9375ZM65.0703 89.9375H51.8828V75.6211H65.0703V89.9375ZM76.0078 43.9727C76.6512 43.9721 77.2884 44.0985 77.883 44.3445C78.4775 44.5905 79.0177 44.9513 79.4727 45.4062C79.9277 45.8612 80.2884 46.4014 80.5344 46.9959C80.7804 47.5905 80.9068 48.2277 80.9063 48.8711V89.9375H68.8398V75.9961C68.8388 74.8972 68.4018 73.8436 67.6248 73.0666C66.8478 72.2896 65.7942 71.8526 64.6953 71.8516H35.3047C34.2058 71.8526 33.1522 72.2896 32.3752 73.0666C31.5982 73.8436 31.1612 74.8972 31.1602 75.9961V89.9375H19.1055V14.9609C19.105 14.3175 19.2313 13.6803 19.4773 13.0858C19.7233 12.4912 20.0841 11.951 20.539 11.4961C20.994 11.0411 21.5342 10.6803 22.1287 10.4343C22.7233 10.1883 23.3605 10.062 24.0039 10.0625H60.1563C60.801 10.0599 61.4399 10.1848 62.0362 10.4298C62.6326 10.6749 63.1746 11.0354 63.6312 11.4905C64.0879 11.9457 64.45 12.4866 64.697 13.0822C64.944 13.6777 65.0708 14.3162 65.0703 14.9609V42.0859C65.0729 42.5848 65.2706 43.0629 65.6211 43.418C65.7956 43.5936 66.0031 43.7331 66.2317 43.8283C66.4603 43.9235 66.7055 43.9725 66.9531 43.9727H76.0078Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_6"
          d="M34.1759 22.1211C33.5783 22.1175 32.9932 22.2917 32.4949 22.6217C31.9966 22.9516 31.6078 23.4224 31.3779 23.9739C31.1479 24.5255 31.0873 25.1331 31.2037 25.7192C31.32 26.3054 31.6082 26.8437 32.0314 27.2656C32.6081 27.8222 33.3783 28.1333 34.1798 28.1333C34.9813 28.1333 35.7515 27.8222 36.3283 27.2656C36.7507 26.8444 37.0386 26.3072 37.1554 25.7221C37.2721 25.1371 37.2124 24.5305 36.984 23.9794C36.7555 23.4283 36.3685 22.9574 35.872 22.6266C35.3756 22.2958 34.792 22.1198 34.1954 22.1211H34.1759Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_7"
          d="M36.3281 58.9141C36.7497 58.4923 37.0368 57.9549 37.1531 57.37C37.2693 56.7851 37.2096 56.1788 36.9813 55.6278C36.753 55.0769 36.3665 54.606 35.8706 54.2746C35.3747 53.9433 34.7917 53.7665 34.1953 53.7665C33.5989 53.7665 33.0159 53.9433 32.5201 54.2746C32.0242 54.606 31.6376 55.0769 31.4094 55.6278C31.1811 56.1788 31.1213 56.7851 31.2375 57.37C31.3538 57.9549 31.6409 58.4923 32.0625 58.9141C32.6377 59.4615 33.4013 59.7667 34.1953 59.7667C34.9893 59.7667 35.753 59.4615 36.3281 58.9141Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_8"
          d="M34.1757 37.9414C33.5782 37.9389 32.9933 38.114 32.4954 38.4444C31.9976 38.7749 31.6091 39.2458 31.3793 39.7974C31.1495 40.3491 31.0888 40.9565 31.2049 41.5427C31.321 42.1289 31.6086 42.6674 32.0312 43.0898C32.6064 43.6372 33.37 43.9425 34.164 43.9425C34.958 43.9425 35.7216 43.6372 36.2968 43.0898C36.7187 42.6681 37.0061 42.1307 37.1225 41.5456C37.239 40.9605 37.1792 40.354 36.9509 39.8029C36.7226 39.2517 36.3359 38.7807 35.8399 38.4493C35.3438 38.118 34.7606 37.9412 34.164 37.9414H34.1757Z"
          fill="#4ABEFF"
        />
      </g>
    </svg>
  ),
  shop: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="shop-blue 1">
        <path
          id="Vector"
          d="M75.0313 93.7031H24.9688C23.6124 93.7036 22.2691 93.4368 21.0158 92.918C19.7625 92.3991 18.6238 91.6384 17.6646 90.6792C16.7054 89.7201 15.9447 88.5813 15.4258 87.328C14.907 86.0747 14.6402 84.7314 14.6407 83.375V50C14.6288 49.7317 14.6714 49.4638 14.7658 49.2125C14.8603 48.9611 15.0047 48.7315 15.1903 48.5375C15.3759 48.3434 15.5989 48.189 15.8458 48.0835C16.0928 47.978 16.3585 47.9236 16.627 47.9236C16.8956 47.9236 17.1613 47.978 17.4082 48.0835C17.6552 48.189 17.8782 48.3434 18.0638 48.5375C18.2494 48.7315 18.3938 48.9611 18.4882 49.2125C18.5827 49.4638 18.6253 49.7317 18.6134 50V83.375C18.6123 84.2099 18.776 85.0368 19.095 85.8083C19.4141 86.5799 19.8822 87.2809 20.4725 87.8713C21.0629 88.4616 21.7639 88.9298 22.5355 89.2488C23.307 89.5678 24.1339 89.7315 24.9688 89.7305H75.0313C76.7132 89.73 78.3277 89.0693 79.5274 87.8906C80.1185 87.3008 80.5871 86.5999 80.9062 85.8283C81.2253 85.0567 81.3886 84.2295 81.3868 83.3945V50C81.3749 49.7317 81.4175 49.4638 81.5119 49.2125C81.6064 48.9611 81.7508 48.7315 81.9364 48.5375C82.122 48.3434 82.345 48.189 82.5919 48.0835C82.8389 47.978 83.1046 47.9236 83.3731 47.9236C83.6416 47.9236 83.9074 47.978 84.1543 48.0835C84.4012 48.189 84.6242 48.3434 84.8099 48.5375C84.9955 48.7315 85.1399 48.9611 85.2343 49.2125C85.3288 49.4638 85.3714 49.7317 85.3595 50V83.375C85.3629 84.7319 85.0974 86.076 84.5785 87.3298C84.0596 88.5836 83.2974 89.7221 82.336 90.6797C80.3939 92.6095 77.7692 93.6959 75.0313 93.7031ZM91.7188 31.1289C91.4576 31.1294 91.1989 31.0783 90.9576 30.9784C90.7162 30.8785 90.497 30.7318 90.3126 30.5469L71.9141 12.1484C71.3224 11.5502 70.6172 11.0761 69.8399 10.7539C69.0622 10.4458 68.235 10.2816 67.3985 10.2695H32.5977C31.7596 10.2675 30.9294 10.4323 30.1555 10.7542C29.3816 11.0761 28.6794 11.5487 28.0899 12.1445L9.68758 30.5469C9.31091 30.9008 8.81125 31.0941 8.29448 31.0858C7.77772 31.0776 7.28447 30.8685 6.91927 30.5027C6.55407 30.137 6.34562 29.6435 6.3381 29.1267C6.33058 28.6099 6.52458 28.1106 6.87899 27.7344L25.2735 9.33984C26.2328 8.37498 27.3734 7.60938 28.6297 7.08714C29.886 6.5649 31.2333 6.29632 32.5938 6.29688H67.4063C68.7678 6.29632 70.1159 6.56526 71.373 7.08819C72.6301 7.61113 73.7712 8.37771 74.7305 9.34375L93.1212 27.7344C93.3991 28.0122 93.5885 28.3662 93.6654 28.7516C93.7423 29.137 93.7033 29.5366 93.5532 29.8998C93.4032 30.263 93.1488 30.5736 92.8223 30.7924C92.4958 31.0112 92.1118 31.1283 91.7188 31.1289Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_2"
          d="M62.5 93.7031C61.9791 93.6949 61.4824 93.4822 61.117 93.111C60.7516 92.7397 60.5468 92.2397 60.5469 91.7188V75.0313C60.5474 74.1963 60.3834 73.3694 60.0642 72.5979C59.7451 71.8264 59.277 71.1253 58.6868 70.5347C58.0966 69.9442 57.3958 69.4757 56.6244 69.156C55.8531 68.8364 55.0264 68.6719 54.1914 68.6719H45.8281C44.9932 68.6719 44.1664 68.8364 43.3951 69.156C42.6238 69.4757 41.923 69.9442 41.3328 70.5347C40.7425 71.1253 40.2745 71.8264 39.9553 72.5979C39.6362 73.3694 39.4721 74.1963 39.4727 75.0313V91.7188C39.45 92.2303 39.2308 92.7134 38.8608 93.0674C38.4907 93.4214 37.9984 93.6189 37.4863 93.6189C36.9743 93.6189 36.4819 93.4214 36.1119 93.0674C35.7419 92.7134 35.5227 92.2303 35.5 91.7188V75.0313C35.4995 73.6746 35.7663 72.3312 36.2851 71.0777C36.8039 69.8241 37.5646 68.6851 38.5237 67.7256C39.4828 66.7662 40.6215 66.0051 41.8748 65.4858C43.1281 64.9665 44.4715 64.6992 45.8281 64.6992H54.1719C56.9118 64.7003 59.5392 65.7891 61.4766 67.7265C63.414 69.664 64.5029 72.2913 64.5039 75.0313V91.7188C64.5039 91.981 64.452 92.2406 64.351 92.4827C64.2501 92.7247 64.1021 92.9443 63.9158 93.1289C63.7295 93.3134 63.5084 93.4592 63.2654 93.5577C63.0224 93.6563 62.7622 93.7057 62.5 93.7031ZM83.3594 51.9844C80.4883 51.8424 77.7393 50.7795 75.5195 48.9531C75.3682 48.8573 75.1928 48.8064 75.0137 48.8064C74.8346 48.8064 74.6591 48.8573 74.5078 48.9531C72.3251 50.7576 69.6241 51.8194 66.7969 51.9844H66.5781C63.7445 51.8218 61.0365 50.76 58.8477 48.9531C58.6969 48.8576 58.5222 48.8069 58.3438 48.8069C58.1653 48.8069 57.9906 48.8576 57.8398 48.9531C55.6507 50.7595 52.9429 51.8213 50.1094 51.9844H49.8906C47.057 51.8218 44.349 50.76 42.1602 48.9531C42.0094 48.8576 41.8347 48.8069 41.6563 48.8069C41.4778 48.8069 41.3031 48.8576 41.1523 48.9531C38.9635 50.76 36.2555 51.8218 33.4219 51.9844H33.2031C30.3695 51.8218 27.6615 50.76 25.4727 48.9531C25.3219 48.8576 25.1472 48.8069 24.9688 48.8069C24.7903 48.8069 24.6156 48.8576 24.4648 48.9531C22.276 50.76 19.568 51.8218 16.7344 51.9844C15.3697 51.9978 14.016 51.7405 12.7514 51.2275C11.4868 50.7144 10.3365 49.9557 9.36692 48.9953C8.39739 48.0348 7.6279 46.8917 7.10296 45.632C6.57801 44.3723 6.30802 43.021 6.3086 41.6562V29.1562C6.30808 28.8953 6.35903 28.6369 6.45853 28.3957C6.55802 28.1545 6.70411 27.9352 6.88842 27.7506C7.07274 27.5659 7.29167 27.4194 7.53268 27.3194C7.77369 27.2194 8.03205 27.168 8.29297 27.168H91.7188C91.9797 27.168 92.238 27.2194 92.479 27.3194C92.7201 27.4194 92.939 27.5659 93.1233 27.7506C93.3076 27.9352 93.4537 28.1545 93.5532 28.3957C93.6527 28.6369 93.7036 28.8953 93.7031 29.1562V41.6562C93.7036 43.0127 93.4368 44.356 92.918 45.6093C92.3991 46.8626 91.6384 48.0013 90.6792 48.9605C89.7201 49.9196 88.5813 50.6804 87.328 51.1992C86.0747 51.7181 84.7315 51.9849 83.375 51.9844H83.3594ZM75.0156 44.832C76.0483 44.8291 77.0552 45.1547 77.8906 45.7617L78.0039 45.8516C79.5461 47.1433 81.4642 47.9023 83.4727 48.0156C85.1399 47.9859 86.7289 47.303 87.8978 46.1137C89.0666 44.9244 89.7219 43.3238 89.7227 41.6562V31.1289H10.2695V41.6758C10.2685 42.5107 10.4322 43.3376 10.7512 44.1091C11.0703 44.8807 11.5384 45.5817 12.1287 46.1721C12.7191 46.7624 13.4201 47.2305 14.1917 47.5496C14.9632 47.8686 15.7901 48.0323 16.625 48.0313C18.5943 47.8985 20.4702 47.1418 21.9805 45.8711L22.0938 45.7812C22.9344 45.1863 23.9389 44.8668 24.9688 44.8668C25.9986 44.8668 27.0031 45.1863 27.8438 45.7812L27.957 45.8711C29.4695 47.1376 31.3444 47.8925 33.3125 48.0273C35.2843 47.8877 37.1608 47.1259 38.6719 45.8516L38.7852 45.7617C39.6262 45.1678 40.6306 44.849 41.6602 44.849C42.6898 44.849 43.6941 45.1678 44.5352 45.7617L44.6484 45.8516C46.1599 47.1173 48.0332 47.8721 50 48.0078C51.968 47.8724 53.8427 47.1176 55.3555 45.8516L55.4688 45.7617C56.3094 45.1668 57.3139 44.8472 58.3438 44.8472C59.3736 44.8472 60.3781 45.1668 61.2188 45.7617L61.332 45.8516C62.8441 47.1188 64.7192 47.8737 66.6875 48.0078C68.6546 47.8737 70.5285 47.1187 72.0391 45.8516L72.1563 45.7617C72.9919 45.1552 73.9986 44.8296 75.0313 44.832H75.0156Z"
          fill="#4ABEFF"
        />
      </g>
    </svg>
  ),
  doc: (
    <svg
      width="89"
      height="100"
      viewBox="0 0 89 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="doc02-blue 1">
        <path
          id="Vector"
          d="M36.2031 52.3438H40.8008C41.1065 52.3444 41.4093 52.2843 41.6916 52.1669C41.9739 52.0496 42.2301 51.8773 42.4453 51.6602C42.7694 51.3349 42.99 50.9209 43.079 50.4704C43.1681 50.02 43.1218 49.5532 42.9459 49.1291C42.7699 48.7049 42.4723 48.3424 42.0905 48.0872C41.7088 47.832 41.26 47.6957 40.8008 47.6953H36.2031C35.5869 47.6969 34.9961 47.9411 34.5586 48.375C34.1268 48.8135 33.8848 49.4042 33.8848 50.0195C33.8848 50.6349 34.1268 51.2256 34.5586 51.6641C34.9961 52.098 35.5869 52.3422 36.2031 52.3438Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_2"
          d="M63.7971 33.9258C64.3616 33.8524 64.8802 33.5761 65.2559 33.1484C65.6317 32.7207 65.8389 32.1709 65.8389 31.6016C65.8389 31.0323 65.6317 30.4824 65.2559 30.0547C64.8802 29.627 64.3616 29.3507 63.7971 29.2773H36.2033C35.8728 29.2344 35.5369 29.2625 35.2181 29.3596C34.8993 29.4568 34.6049 29.6208 34.3545 29.8408C34.1041 30.0607 33.9035 30.3316 33.7661 30.6352C33.6287 30.9388 33.5576 31.2683 33.5576 31.6016C33.5576 31.9348 33.6287 32.2643 33.7661 32.5679C33.9035 32.8716 34.1041 33.1424 34.3545 33.3624C34.6049 33.5823 34.8993 33.7464 35.2181 33.8435C35.5369 33.9407 35.8728 33.9687 36.2033 33.9258H63.7971Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_3"
          d="M77.5977 6.28125H22.4023C20.5665 6.28125 18.8059 7.01052 17.5078 8.30862C16.2097 9.60672 15.4805 11.3673 15.4805 13.2031V86.7969C15.4805 88.6327 16.2097 90.3933 17.5078 91.6914C18.8059 92.9895 20.5665 93.7187 22.4023 93.7187H57.293C58.2022 93.7205 59.1028 93.5422 59.9429 93.1943C60.7829 92.8463 61.5458 92.3355 62.1875 91.6914L82.5 71.3789C83.1447 70.7376 83.6558 69.9748 84.0038 69.1346C84.3517 68.2945 84.5297 67.3937 84.5273 66.4844V13.2031C84.5273 11.3673 83.7981 9.60672 82.5 8.30862C81.2019 7.01052 79.4413 6.28125 77.6055 6.28125H77.5977ZM53.6289 62.8281C53.1992 63.2571 52.8586 63.7668 52.6266 64.3279C52.3947 64.889 52.276 65.4905 52.2773 66.0977V89.0625H20.1289V10.9375H79.8945V61.4844H56.8984C56.2918 61.482 55.6907 61.5995 55.1296 61.8301C54.5685 62.0607 54.0585 62.3999 53.6289 62.8281ZM56.9219 90.3867V66.1211H81.1875L56.9219 90.3867Z"
          fill="#4ABEFF"
        />
      </g>
    </svg>
  ),
  config: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="config-blue 1">
        <path
          id="Vector"
          d="M49.0234 64.6016C46.1346 64.6016 43.3106 63.7449 40.9087 62.1398C38.5067 60.5348 36.6347 58.2535 35.5294 55.5845C34.424 52.9154 34.135 49.9786 34.6989 47.1453C35.2628 44.312 36.6542 41.7095 38.6972 39.6671C40.7402 37.6246 43.343 36.2339 46.1765 35.6708C49.0099 35.1077 51.9467 35.3975 54.6154 36.5035C57.2842 37.6096 59.5649 39.4822 61.1693 41.8846C62.7737 44.2869 63.6297 47.1112 63.6289 50C63.6248 53.872 62.0845 57.5841 59.3463 60.3217C56.608 63.0592 52.8954 64.5985 49.0234 64.6016ZM49.0234 40.0234C47.0496 40.0204 45.1192 40.6028 43.4765 41.6972C41.8338 42.7916 40.5527 44.3486 39.7952 46.1713C39.0377 47.994 38.8379 50.0004 39.2211 51.9367C39.6042 53.873 40.5532 55.6521 41.9478 57.049C43.3424 58.4458 45.12 59.3975 47.0557 59.7837C48.9914 60.1699 50.9982 59.9733 52.8221 59.2186C54.646 58.464 56.205 57.1853 57.3019 55.5443C58.3989 53.9033 58.9844 51.9738 58.9844 50C58.9813 47.3577 57.9313 44.8243 56.0644 42.9544C54.1975 41.0846 51.6657 40.0307 49.0234 40.0234Z"
          fill="#4ABEFF"
        />
        <path
          id="Vector_2"
          d="M49.0232 93.2813C44.9061 93.2813 42.8357 93.2813 40.91 92.4805C38.3341 91.4137 36.287 89.3681 35.2186 86.793C34.7085 85.4047 34.4518 83.9361 34.4607 82.457C34.4681 81.91 34.366 81.367 34.1605 80.86C33.955 80.353 33.6502 79.8922 33.2641 79.5046C32.878 79.117 32.4183 78.8106 31.9121 78.6032C31.4058 78.3958 30.8633 78.2916 30.3162 78.2969C29.593 78.2977 28.8814 78.479 28.2459 78.8242C26.4998 79.75 25.3006 80.1875 24.0857 80.3516C22.7168 80.5334 21.3254 80.443 19.9914 80.0858C18.6574 79.7285 17.4071 79.1112 16.3123 78.2695C14.66 76.9961 13.6248 75.2109 11.5701 71.6602C9.51543 68.1094 8.46855 66.2773 8.19511 64.2109C7.83247 61.4475 8.58129 58.6532 10.2771 56.4414C11.1326 55.3242 12.2303 54.4883 13.6443 53.6133C14.2826 53.2499 14.8133 52.7239 15.1825 52.0889C15.5516 51.454 15.7461 50.7325 15.7461 49.998C15.7461 49.2635 15.5516 48.5421 15.1825 47.9072C14.8133 47.2722 14.2826 46.7462 13.6443 46.3828C11.992 45.3437 11.0154 44.5273 10.2693 43.5625C8.5752 41.3484 7.82664 38.5535 8.1873 35.7891C8.45293 33.7305 9.47636 31.9609 11.5115 28.4336C13.5467 24.9063 14.6365 23.0156 16.2967 21.7344C17.3897 20.8893 18.6397 20.2698 19.9742 19.9117C21.3086 19.5536 22.7008 19.4641 24.0701 19.6484C25.2889 19.8086 26.4881 20.2461 28.2107 21.1602C28.8533 21.5143 29.5747 21.7011 30.3084 21.7031C31.4015 21.693 32.4473 21.2559 33.2224 20.4852C33.9975 19.7144 34.4406 18.6711 34.4568 17.5781C34.5311 15.6016 34.7498 14.3437 35.2381 13.2109C35.7601 11.9353 36.5287 10.7751 37.4998 9.79687C38.4736 8.81828 39.6329 8.04402 40.91 7.51953C42.8357 6.71875 44.9217 6.71875 49.0232 6.71875C53.1248 6.71875 55.2107 6.71875 57.1404 7.51953C58.4158 8.04705 59.5747 8.82093 60.5506 9.79686C61.5265 10.7728 62.3004 11.9316 62.8279 13.207C63.3377 14.5955 63.5957 16.0639 63.5896 17.543C63.5823 18.0897 63.6843 18.6323 63.8896 19.1391C64.0948 19.6458 64.3992 20.1065 64.7849 20.494C65.1706 20.8815 65.6298 21.1881 66.1356 21.3957C66.6414 21.6033 67.1835 21.7079 67.7303 21.7031H67.7498C68.4736 21.7032 69.1858 21.5205 69.8201 21.1719C71.5701 20.2461 72.7693 19.8086 73.9842 19.6484C75.3529 19.4672 76.7439 19.5574 78.0777 19.914C79.4115 20.2705 80.662 20.8865 81.7576 21.7266C83.41 23.0039 84.4412 24.7891 86.4998 28.3437C88.5584 31.8984 89.5975 33.7227 89.8709 35.7891C90.0525 37.1571 89.9624 38.5476 89.6058 39.8809C89.2492 41.2141 88.6331 42.4639 87.7928 43.5586C86.8435 44.6905 85.7024 45.6465 84.4217 46.3828C83.9438 46.6493 83.5239 47.0086 83.1869 47.4396C82.8498 47.8707 82.6023 48.3647 82.4589 48.8928C82.3155 49.4208 82.2791 49.9722 82.3519 50.5146C82.4247 51.0569 82.6051 51.5792 82.8826 52.0508C83.2442 52.6901 83.7615 53.2276 84.3865 53.6133C85.6795 54.3515 86.8314 55.313 87.7889 56.4531C88.6297 57.5477 89.2464 58.7973 89.6037 60.1305C89.9609 61.4637 90.0517 62.8543 89.8709 64.2227C89.6053 66.2852 88.5818 68.0547 86.5467 71.582C84.4412 75.2305 83.4217 77.0156 81.7576 78.2852C79.5435 79.9793 76.7487 80.7279 73.9842 80.3672C72.7654 80.2031 71.5662 79.7656 69.8475 78.8555C69.2051 78.5008 68.4836 78.3141 67.7498 78.3125H67.7303C67.184 78.3083 66.6424 78.4131 66.1371 78.6207C65.6319 78.8282 65.173 79.1345 64.7875 79.5215C64.402 79.9085 64.0975 80.3684 63.8918 80.8745C63.6861 81.3805 63.5834 81.9225 63.5896 82.4687C63.5154 84.4219 63.2967 85.6719 62.8318 86.8047C62.3036 88.0807 61.529 89.2401 60.5524 90.2167C59.5759 91.1933 58.4165 91.9678 57.1404 92.4961C55.2107 93.2812 53.1443 93.2813 49.0232 93.2813ZM30.2967 73.668H30.3396C32.6374 73.6677 34.8428 74.5722 36.4789 76.1855C38.1149 77.7989 39.05 79.9915 39.0818 82.2891C39.1326 83.6484 39.2498 84.4375 39.4725 85.0234C39.7681 85.7387 40.2017 86.3887 40.7486 86.9363C41.2956 87.4839 41.945 87.9184 42.66 88.2148C43.7498 88.6719 45.6287 88.6719 49.0232 88.6719C52.4178 88.6719 54.2928 88.6719 55.3709 88.2266C56.8098 87.6259 57.9538 86.4819 58.5545 85.043C58.7967 84.457 58.9139 83.6602 58.9451 82.3086C58.9806 80.7939 59.4026 79.3134 60.171 78.0076C60.9394 76.7019 62.0288 75.6141 63.3357 74.8477C64.6631 74.0937 66.1608 73.6904 67.6873 73.6758C69.2035 73.6581 70.6981 74.0364 72.0232 74.7734C73.1951 75.3945 73.9412 75.6875 74.574 75.7734C75.3396 75.8734 76.1175 75.8216 76.8631 75.6211C77.6089 75.423 78.3075 75.0777 78.9178 74.6055C79.8435 73.8984 80.7732 72.2852 82.4685 69.3516C84.1639 66.418 85.117 64.7656 85.2654 63.6211C85.3663 62.8531 85.3147 62.0727 85.1136 61.3247C84.9126 60.5767 84.5659 59.8756 84.0935 59.2617C83.7029 58.7695 83.0818 58.2695 81.9256 57.5391C80.6246 56.7591 79.548 55.6553 78.8004 54.3355C78.0528 53.0157 77.6599 51.5247 77.6599 50.0078C77.6599 48.491 78.0528 47 78.8004 45.6801C79.548 44.3603 80.6246 43.2566 81.9256 42.4766C83.0975 41.7461 83.7068 41.2422 84.0857 40.75C85.0344 39.512 85.4555 37.9494 85.2576 36.4023C85.1053 35.2305 84.1717 33.6289 82.4842 30.6953C80.7967 27.7617 79.8631 26.1094 78.9334 25.3906C77.7041 24.4426 76.1489 24.0211 74.6092 24.2187C73.9842 24.3008 73.2342 24.6094 72.031 25.2344C70.7018 25.9618 69.2074 26.3343 67.6923 26.316C66.1771 26.2977 64.6922 25.8892 63.3809 25.1299C62.0696 24.3706 60.9761 23.2861 60.2059 21.9811C59.4358 20.6761 59.015 19.1947 58.9842 17.6797C58.9334 16.3516 58.8162 15.5586 58.5935 14.9805C58.3004 14.2654 57.8674 13.616 57.3201 13.0703C56.7736 12.523 56.1245 12.089 55.41 11.793C54.3318 11.3477 52.4646 11.3477 49.0662 11.3477C45.6678 11.3477 43.8006 11.3477 42.7225 11.793C42.0084 12.0881 41.3593 12.5208 40.8123 13.0664C40.2654 13.6124 39.8325 14.2617 39.5389 14.9766C39.2967 15.5625 39.1756 16.3555 39.1248 17.7109C39.0817 19.2247 38.6543 20.7026 37.8828 22.0057C37.1113 23.3088 36.0211 24.3943 34.7146 25.1602C33.3796 25.9162 31.8739 26.3195 30.3396 26.332H30.2967C28.795 26.332 27.3175 25.9545 25.9998 25.2344C24.8318 24.6094 24.0857 24.3164 23.4373 24.2187C22.6718 24.1183 21.8939 24.1701 21.1485 24.3712C20.403 24.5723 19.7047 24.9187 19.0936 25.3906C18.1639 26.1094 17.2303 27.7344 15.535 30.6641C13.8396 33.5937 12.8982 35.2344 12.7498 36.3789C12.6518 37.1465 12.7076 37.926 12.9139 38.6719C13.113 39.4177 13.4568 40.1171 13.9256 40.7305C14.3162 41.2266 14.9412 41.7266 16.0936 42.4531C17.3954 43.2329 18.4729 44.3367 19.2211 45.657C19.9692 46.9772 20.3625 48.4688 20.3625 49.9863C20.3625 51.5038 19.9692 52.9954 19.2211 54.3157C18.4729 55.6359 17.3954 56.7398 16.0936 57.5195C14.9217 58.25 14.3084 58.7539 13.9334 59.2461C13.461 59.8577 13.1143 60.5567 12.9131 61.3029C12.712 62.049 12.6605 62.8276 12.7615 63.5938C12.9139 64.7656 13.8436 66.3672 15.535 69.3008C17.2264 72.2344 18.1834 73.875 19.1092 74.5898C19.7201 75.0601 20.4186 75.404 21.1639 75.6016C21.9094 75.8027 22.6873 75.8545 23.4529 75.7539C24.0818 75.668 24.8279 75.3633 26.0271 74.7422C27.3379 74.0321 28.806 73.6628 30.2967 73.668Z"
          fill="#4ABEFF"
        />
      </g>
    </svg>
  ),
  chart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 64 64"
    >
      <g transform="matrix(1.1800000000000002,0,0,1.1800000000000002,-5.760044975280742,-5.760000085830697)">
        <path
          d="M57.5 54H8V8.5a1.5 1.5 0 0 0-3 0v47A1.5 1.5 0 0 0 6.5 57h51a1.5 1.5 0 0 0 0-3zm-46.925-6.445a1.498 1.498 0 0 0 2.048-.554l6.258-10.906 6.093 6.865a1.5 1.5 0 0 0 2.466-.328l8.444-16.982 9.027 10.404a1.483 1.483 0 0 0 1.177.516 1.5 1.5 0 0 0 1.145-.586l11.457-14.92a1.5 1.5 0 0 0-2.38-1.828L45.973 32.7l-9.298-10.715a1.5 1.5 0 0 0-2.476.315l-8.456 17.007-6.002-6.764a1.5 1.5 0 0 0-2.423.25L10.02 45.507a1.5 1.5 0 0 0 .554 2.047z"
          fill="#069dde"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  ),
  new: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      className=""
    >
      <g>
        <path
          d="M257 0C116.39 0 0 114.39 0 255s116.39 257 257 257 255-116.39 255-257S397.61 0 257 0zm135 285H287v107c0 16.54-13.47 30-30 30-16.54 0-30-13.46-30-30V285H120c-16.54 0-30-13.46-30-30s13.46-30 30-30h107V120c0-16.54 13.46-30 30-30 16.53 0 30 13.46 30 30v105h105c16.53 0 30 13.46 30 30s-13.47 30-30 30z"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  ),
  code: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="469.33334"
      height="426.66666"
      x="0"
      y="0"
      viewBox="0 0 22 20"
      id="svg8"
    >
      <defs id="defs12" />
      <g id="g6" transform="translate(-1,-2)">
        <g data-name="Layer 2" id="g4">
          <path
            d="m 15.5,18 a 1.001,1.001 0 0 1 -1,-1 v -1.846 a 1,1 0 0 1 2,0 V 17 a 1.001,1.001 0 0 1 -1,1 z m 0,-4.615 a 1.001,1.001 0 0 1 -1,-1 V 7 a 1,1 0 0 1 2,0 v 5.385 a 1.001,1.001 0 0 1 -1,1 z M 19,18 A 1.001,1.001 0 0 1 18,17 V 7 a 1,1 0 0 1 2,0 v 10 a 1.001,1.001 0 0 1 -1,1 z M 5,18 A 1.001,1.001 0 0 1 4,17 V 7 a 1,1 0 0 1 2,0 v 10 a 1.001,1.001 0 0 1 -1,1 z m 3.5,0 a 1.001,1.001 0 0 1 -1,-1 v -1.846 a 1,1 0 0 1 2,0 V 17 a 1.001,1.001 0 0 1 -1,1 z m 0,-4.615 a 1.001,1.001 0 0 1 -1,-1 V 7 a 1,1 0 0 1 2,0 v 5.385 a 1.001,1.001 0 0 1 -1,1 z M 12,18 A 1.001,1.001 0 0 1 11,17 V 7 a 1,1 0 0 1 2,0 v 10 a 1.001,1.001 0 0 1 -1,1 z M 2,7 A 1.001,1.001 0 0 1 1,6 V 4 A 2.002,2.002 0 0 1 3,2 H 5 A 1,1 0 0 1 5,4 H 3 V 6 A 1.001,1.001 0 0 1 2,7 Z M 22,7 A 1.001,1.001 0 0 1 21,6 V 4 h -2 a 1,1 0 0 1 0,-2 h 2 a 2.002,2.002 0 0 1 2,2 v 2 a 1.001,1.001 0 0 1 -1,1 z m -3,15 a 1,1 0 0 1 0,-2 h 2 v -2 a 1,1 0 0 1 2,0 v 2 a 2.002,2.002 0 0 1 -2,2 z M 3,22 A 2.002,2.002 0 0 1 1,20 v -2 a 1,1 0 0 1 2,0 v 2 h 2 a 1,1 0 0 1 0,2 z"
            data-original="#000000"
            id="path2"
            fill="#4abeff"
          />
        </g>
      </g>
    </svg>
  ),
  save: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      version="1.1"
      id="svg3"
      fill="none"
    >
      <path
        id="Vector"
        d="M11.3889 14.5H3.61111M11.3889 14.5H12.0134C12.883 14.5 13.3178 14.5 13.6499 14.3304C13.9431 14.1811 14.1811 13.9431 14.3304 13.6507C14.5 13.3186 14.5 12.883 14.5 12.0134V5.33778C14.5 4.98778 14.5 4.81278 14.4627 4.64633C14.4296 4.49783 14.3748 4.355 14.3001 4.22244C14.2177 4.07467 14.101 3.94633 13.8723 3.692L11.7296 1.31044C11.4643 1.01644 11.3298 0.867111 11.1688 0.759778C11.0236 0.663425 10.8632 0.592172 10.6943 0.549C10.5046 0.5 10.3 0.5 9.89167 0.5H2.98889C2.11778 0.5 1.68222 0.5 1.34933 0.669556C1.05662 0.818646 0.818646 1.05662 0.669556 1.34933C0.5 1.68222 0.5 2.11778 0.5 2.98889V12.0111C0.5 12.8822 0.5 13.3178 0.669556 13.6499C0.818889 13.9431 1.05611 14.1811 1.34933 14.3304C1.68144 14.5 2.117 14.5 2.98656 14.5H3.61111M11.3889 14.5V11.5421C11.3889 10.6726 11.3889 10.237 11.2193 9.90489C11.07 9.61212 10.8317 9.37416 10.5388 9.22511C10.2067 9.05556 9.77111 9.05556 8.9 9.05556H6.1C5.22889 9.05556 4.79333 9.05556 4.46044 9.22511C4.16773 9.3742 3.92976 9.61217 3.78067 9.90489C3.61111 10.2378 3.61111 10.6733 3.61111 11.5444V14.5M9.83333 3.61111H5.16667"
        stroke="#4ABEFF"
        fill="transparent"
      />
    </svg>
  ),
  remove: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 427 427.001"
      id="svg10"
    >
      <g
        id="g8"
        transform="translate(40.101511,0.00114807)"
        opacity="1"
        fill="#4abeff"
      >
        <path
          d="m 232.398,154.703 c -5.523,0 -10,4.477 -10,10 v 189 c 0,5.52 4.477,10 10,10 5.524,0 10,-4.48 10,-10 v -189 c 0,-5.523 -4.476,-10 -10,-10 z m -118,0 c -5.523,0 -10,4.477 -10,10 v 189 c 0,5.52 4.477,10 10,10 5.524,0 10,-4.48 10,-10 v -189 c 0,-5.523 -4.476,-10 -10,-10 z m 0,0"
          data-original="#000000"
          id="path2"
          opacity="1"
          fill="#4abeff"
        />
        <path
          d="M 28.398,127.121 V 373.5 c 0,14.563 5.34,28.238 14.668,38.05 A 49.246,49.246 0 0 0 78.796,427 H 268 a 49.233,49.233 0 0 0 35.73,-15.45 c 9.329,-9.812 14.668,-23.487 14.668,-38.05 V 127.121 c 18.543,-4.922 30.559,-22.836 28.079,-41.863 C 343.992,66.234 327.785,52.004 308.597,52 H 257.398 V 39.5 A 39.289,39.289 0 0 0 245.859,11.469 39.288,39.288 0 0 0 217.797,0 H 129 A 39.288,39.288 0 0 0 100.937,11.469 39.289,39.289 0 0 0 89.398,39.5 V 52 H 38.2 C 19.012,52.004 2.805,66.234 0.32,85.258 c -2.48,19.027 9.535,36.941 28.078,41.863 z M 268,407 H 78.797 C 61.699,407 48.398,392.312 48.398,373.5 V 128 h 250 v 245.5 c 0,18.813 -13.3,33.5 -30.398,33.5 z M 109.398,39.5 A 19.25,19.25 0 0 1 115.074,25.605 19.26,19.26 0 0 1 129,20 h 88.797 a 19.26,19.26 0 0 1 13.926,5.605 19.244,19.244 0 0 1 5.675,13.895 V 52 h -128 z M 38.2,72 h 270.399 c 9.941,0 18,8.059 18,18 0,9.941 -8.059,18 -18,18 h -270.4 c -9.941,0 -18,-8.059 -18,-18 0,-9.941 8.059,-18 18,-18 z m 0,0"
          data-original="#000000"
          id="path4"
          opacity="1"
          fill="#4abeff"
        />
        <path
          d="m 173.398,154.703 c -5.523,0 -10,4.477 -10,10 v 189 c 0,5.52 4.477,10 10,10 5.524,0 10,-4.48 10,-10 v -189 c 0,-5.523 -4.476,-10 -10,-10 z m 0,0"
          data-original="#000000"
          id="path6"
          opacity="1"
          fill="#4abeff"
        />
      </g>
    </svg>
  ),
  hearingAids: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 682.667 682.667"
      id="svg19"
    >
      <defs id="defs23" />
      <g id="g17" fill="#4abeff">
        <g
          transform="matrix(1.33333,0,0,-1.33333,0,682.667)"
          id="g15"
          fill="#4abeff"
        >
          <path
            d="m 0,0 v 46 c 0,91.127 -74.873,165 -166,165 -91.127,0 -165,-73.873 -165,-165 v -221.906 c 0,-48.735 36.492,-92.418 85.16,-94.967 51.903,-2.718 94.84,38.563 94.84,89.873 0,22.069 -7.943,42.282 -21.127,57.938 C -215.324,-71.764 -241,-6.064 -241,61 c 0,49.705 40.294,90 90,90 C -68.5,151 0,82.5 0,0"
            transform="translate(384,286)"
            strokeMiterlimit="10"
            data-original="#000000"
            id="path7"
            fill="#4abeff"
          />
          <path
            d="m 0,0 c 12.568,5.32 26.389,8.262 40.896,8.262 16.892,0 32.854,-3.99 46.993,-11.077"
            transform="translate(57.105,368.738)"
            strokeMiterlimit="10"
            data-original="#000000"
            id="path9"
            fill="#4abeff"
          />
          <path
            d="m 0,0 c -10.232,18.456 -29.912,30.948 -52.51,30.948 -33.136,0 -60,-26.863 -60,-60 0,-33.137 26.864,-60 60,-60 22.598,0 42.278,12.492 52.51,30.948"
            transform="translate(436.51,255.052)"
            strokeMiterlimit="10"
            data-original="#000000"
            id="path11"
            fill="#4abeff"
          />
          <path
            d="m 0,0 c 0,-16.569 -13.432,-30 -30,-30 -16.568,0 -30,13.431 -30,30 0,16.569 13.432,30 30,30 C -13.432,30 0,16.569 0,0 Z"
            transform="translate(459,226)"
            strokeMiterlimit="10"
            data-original="#000000"
            id="path13"
            fill="#4abeff"
          />
        </g>
      </g>
    </svg>
  ),
  hearingAidsGray: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 682.667 682.667"
      id="svg19"
    >
      <defs id="defs23" />
      <g id="g17" fill="#afafaf">
        <g
          transform="matrix(1.33333,0,0,-1.33333,0,682.667)"
          id="g15"
          fill="#afafaf"
        >
          <path
            d="m 0,0 v 46 c 0,91.127 -74.873,165 -166,165 -91.127,0 -165,-73.873 -165,-165 v -221.906 c 0,-48.735 36.492,-92.418 85.16,-94.967 51.903,-2.718 94.84,38.563 94.84,89.873 0,22.069 -7.943,42.282 -21.127,57.938 C -215.324,-71.764 -241,-6.064 -241,61 c 0,49.705 40.294,90 90,90 C -68.5,151 0,82.5 0,0"
            transform="translate(384,286)"
            strokeMiterlimit="10"
            data-original="#000000"
            id="path7"
            fill="#afafaf"
          />
          <path
            d="m 0,0 c 12.568,5.32 26.389,8.262 40.896,8.262 16.892,0 32.854,-3.99 46.993,-11.077"
            transform="translate(57.105,368.738)"
            strokeMiterlimit="10"
            data-original="#000000"
            id="path9"
            fill="#afafaf"
          />
          <path
            d="m 0,0 c -10.232,18.456 -29.912,30.948 -52.51,30.948 -33.136,0 -60,-26.863 -60,-60 0,-33.137 26.864,-60 60,-60 22.598,0 42.278,12.492 52.51,30.948"
            transform="translate(436.51,255.052)"
            strokeMiterlimit="10"
            data-original="#000000"
            id="path11"
            fill="#afafaf"
          />
          <path
            d="m 0,0 c 0,-16.569 -13.432,-30 -30,-30 -16.568,0 -30,13.431 -30,30 0,16.569 13.432,30 30,30 C -13.432,30 0,16.569 0,0 Z"
            transform="translate(459,226)"
            strokeMiterlimit="10"
            data-original="#000000"
            id="path13"
            fill="#afafaf"
          />
        </g>
      </g>
    </svg>
  ),
  frames: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 32 32"
      id="svg6"
    >
      <g
        transform="matrix(1.1399999999999992,0,0,1.1399999999999992,-2.239999999999988,-2.2473262023925606)"
        id="g4"
      >
        <path
          d="M30 17.8c0-.5-.2-.9-.6-1.2L25.1 6.2c-.9-2-2.8-2.4-4.8-1.9-.5.1-.9.6-.9 1.1.1.5.6.9 1.1.9.7-.1 2.1-.5 2.7.7 0 0 4 9.9 4 10-.9-.6-2.1-1-3.3-1-1.6 0-3.1.7-4.2 1.7-2.7-1.4-5.2-1.3-7.7 0-1.1-1.1-2.6-1.7-4.2-1.7-1.2 0-2.3.4-3.2 1l4-9.9c.2-.6 1.1-1.2 2.7-.7.5.1 1.1-.3 1.1-.9.1-.6-.3-1-.9-1.1-2.5-.7-4.1.4-4.7 1.8L2.5 16.6c-.3.3-.5.7-.5 1.2s.3 1 .7 1.3C2.2 20 2 20.9 2 22c0 3.3 2.7 6 6 6s6-2.7 6-6c0-.9-.2-1.8-.6-2.6 1.7-.9 3.4-.9 5.3 0-.5.7-.7 1.6-.7 2.5 0 3.3 2.7 6 6 6s6-2.7 6-6c0-1-.3-2-.7-2.9.4-.2.7-.7.7-1.2zM7.9 25.9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm16.1 0c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
          id="path2"
        />
      </g>
    </svg>
  ),
  contactLenses: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      id="svg12"
    >
      <g id="g10">
        <path
          d="M373.674 337.994c35.694 7.45 57.591 17.516 57.591 28.593 0 22.954-94.021 41.563-210.002 41.563S11.26 389.542 11.26 366.587c0-11.254 22.6-21.463 59.306-28.947 0 0 73.197-13.657 158.799-13.657"
          fill="none"
          stroke="#4abeff"
          strokeWidth="22"
          strokeLinejoin="round"
          data-original="#000000"
          opacity="1"
          id="path2"
        />
        <path
          d="M12.777 371.69C50.84 448.323 129.893 501 221.262 501c91.369 0 170.422-52.677 208.485-129.31"
          fill="none"
          stroke="#4abeff"
          strokeWidth="22"
          data-original="#000000"
          opacity="1"
          id="path4"
        />
        <path
          d="M235.626 360.858c84.739 11.862 172.855-23.632 224.451-99.038 51.597-75.406 52.765-170.395 11.016-245.083"
          fill="none"
          stroke="#4abeff"
          strokeWidth="22"
          strokeLinecap="round"
          strokeLinejoin="round"
          data-original="#33cccc"
          opacity="1"
          id="path6"
        />
        <ellipse
          cx="349.148"
          cy="185.915"
          rx="210.002"
          ry="41.563"
          transform="rotate(-55.619 349.142 185.914)"
          fill="none"
          stroke="#4abeff"
          strokeWidth="22"
          strokeLinecap="round"
          strokeLinejoin="round"
          data-original="#33cccc"
          opacity="1"
          id="ellipse8"
        />
      </g>
    </svg>
  ),
  liquids: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      id="svg8"
    >
      <g id="g6">
        <path
          d="M509.232 433.933c-.044-.161-.103-.308-.161-.469l-42.93-121.465c-4.219-11.981-24.05-11.981-28.268 0l-43.091 121.934c-1.846 5.8-2.769 11.879-2.769 18.045 0 33.087 26.906 59.993 59.993 59.993s59.993-26.906 59.993-59.993c.001-6.166-.922-12.245-2.767-18.045zM151.022 382.155l91.042-91.042 84.842 84.841-91.042 91.042zM458.586 180.65 331.322 53.387c-5.858-5.857-15.353-5.857-21.213 0l-21.211 21.211c-5.857 5.857-5.857 15.353 0 21.211l127.267 127.265c5.857 5.857 15.353 5.857 21.211 0l21.211-21.213c5.857-5.858 5.857-15.354-.001-21.211z"
          opacity="1"
          data-original="#000000"
          id="path2"
          fill="#4abeff"
        />
        <path
          d="m365.291 252.734 19.057-19.057-106.053-106.053-19.057 19.057-19.658-6.567c-27.124-9.041-56.528-2.091-76.743 18.125L13.159 307.916c-17.545 17.543-17.545 46.088 0 63.631l127.265 127.267c17.545 17.543 46.088 17.543 63.633 0l10.606-10.606-95.449-95.447c-5.862-5.862-5.862-15.35 0-21.213l112.258-112.257c5.862-5.862 15.348-5.862 21.211 0l95.449 95.447 5.602-5.602c20.217-20.217 27.155-49.608 18.125-76.743l-6.568-19.659zM507.606 25.634l-21.211-21.21a15.002 15.002 0 0 0-18.788-1.969l-87.356 57.44 71.826 71.826 57.496-87.299a15 15 0 0 0-1.967-18.788z"
          opacity="1"
          data-original="#000000"
          fill="#4abeff"
        />
      </g>
    </svg>
  ),
  various: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 32 32"
      id="svg8"
    >
      <g
        transform="matrix(1.1399999999999992,0,0,1.1399999999999992,-2.239999999999988,-2.2270678949355904)"
        id="g6"
      >
        <g data-name="Layer 2" id="g4">
          <path
            d="M12 17H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3zm1 10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1zM23.5 17a6.5 6.5 0 1 0 6.5 6.5 6.508 6.508 0 0 0-6.5-6.5zm0 11a4.5 4.5 0 1 1 4.5-4.5 4.505 4.505 0 0 1-4.5 4.5zM11.579 15h8.842a3 3 0 0 0 2.555-4.572l-4.421-7.185a3 3 0 0 0-5.11 0l-4.421 7.185A3 3 0 0 0 11.579 15zm-.851-3.523 4.42-7.185a1 1 0 0 1 1.7 0l4.42 7.185A1 1 0 0 1 20.421 13h-8.842a1 1 0 0 1-.851-1.523z"
            fill="#4abeff"
            opacity="1"
            data-original="#000000"
            id="path2"
          />
        </g>
      </g>
    </svg>
  ),
  lens: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 330 330"
      id="svg8"
    >
      <g id="g6">
        <path
          d="M 165,0 C 74.019,0 0,74.019 0,165 0,255.981 74.019,330 165,330 255.981,330 330,255.981 330,165 330,74.019 255.981,0 165,0 Z m 0,300 C 90.56,300 30,239.439 30,165 30,90.561 90.56,30 165,30 c 74.44,0 135,60.561 135,135 0,74.439 -60.561,135 -135,135 z"
          data-original="#000000"
          id="path2"
          fill="#4abeff"
        />
        <circle
          style={{
            fillRule: "evenodd",
            stroke: "#4abeff",
            strokeWidth: 3.22265625,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4,
            paintOrder: "fill",
          }}
          id="path825"
          cx="165"
          cy="165"
          r="79.004234"
          fill="#4abeff"
        />
      </g>
    </svg>
  ),
  sunglasses: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 32 32"
      id="svg6"
    >
      <g
        transform="matrix(1.1399999999999992,0,0,1.1399999999999992,-2.2399999666213795,-2.240326175689688)"
        id="g4"
      >
        <path
          d="M30 17.8c0-.5-.2-.9-.6-1.2L25.1 6.2c-.9-2-2.8-2.4-4.8-1.9-.5.1-.9.6-.9 1.1.1.5.6.9 1.1.9.7-.1 2.1-.5 2.7.7 0 0 4 9.9 4 10-.9-.6-2.1-1-3.3-1-1.6 0-3.1.7-4.2 1.7-2.7-1.4-5.2-1.3-7.7 0-1.1-1.1-2.6-1.7-4.2-1.7-1.2 0-2.3.4-3.2 1l4-9.9c.2-.6 1.1-1.2 2.7-.7.5.1 1.1-.3 1.1-.9.1-.6-.3-1-.9-1.1-2.5-.7-4.1.4-4.6 1.8L2.6 16.6c-.4.3-.6.7-.6 1.2s.3 1 .7 1.3c-.5.8-.7 1.8-.7 2.8 0 3.3 2.7 6 6 6s6-2.7 6-6c0-.9-.2-1.8-.6-2.6 1.7-.9 3.4-.9 5.3 0-.4.8-.7 1.7-.7 2.6 0 3.3 2.7 6 6 6s6-2.7 6-6c0-1-.3-2-.7-2.9.4-.2.7-.7.7-1.2z"
          fill="#4abeff"
          opacity="1"
          data-original="#000000"
          id="path2"
        />
      </g>
    </svg>
  ),
};

export const patientData = {
  idPaciente: -1,
  preferencias: {
    preferenciaOptometria: false,
    preferenciaAudiometria: false,
    preferenciaGafasGraduadas: false,
    preferenciaGafasDeSol: false,
    preferenciaAudifonos: false,
    preferenciaLentillas: false,
    preferenciaVarios: false,
  },
  fidelizacionCategoria: "1",
  descuentoEspecial: "0",
  puntos: 0,
  nif: "",
  tipoNif: "NIF",
  idNif: "00",
  fidelizacion: "",
  nombre: "",
  apellidos: "",
  direccion: "",
  localidad: "",
  provincia: "",
  email: "",
  campana: "",
  recomendado: "",
  sexo: "",
  nacimiento: "",
  codigoPostal: "",
  telefono: "",
  movil: "",
  fax: "",
  carnetConducir: false,
  tieneHijos: false,
  codigoRec: "",
  idPacienteCodigoRec: "",
  personaContactoCodigo: "",
  personaContactoNombre: "",
  personaContactoTelefono: "",
  trabajoProfesion: "",
  trabajoEmpresa: "",
  trabajoTelefono: "",
  consentimientosRGPD: false,
  consentimientosAudiologia: false,
  consentimientosLC: false,
  consentimientosORTOK: false,
  serviciosWhatsapp: true,
  serviciosSMS: true,
  serviciosPostal: true,
  serviciosEmail: true,
  serviciosTelefono: true,
  comercialWhatsapp: false,
  comercialSMS: false,
  comercialPostal: false,
  comercialEmail: false,
  comercialTelefono: false,
  aficiones: [],
  ametropias: [],
  avisos: {
    encargo: false,
    deuda: false,
    cita: "",
  },
};

export const basicOptometry = {
  tipo: "",
  // RX NUEVA
  esfera_d: "",
  esfera_i: "",
  cilindro_d: "",
  cilindro_i: "",
  eje_d: "",
  eje_i: "",
  adicion_d: "",
  adicion_i: "",
  intermedia_d: "",
  intermedia_i: "",
  cerca_d: "",
  cerca_i: "",
  total_d: "",
  total_i: "",
  // Datos
  optometrista: "",
  oftalmologo: "",
  numero_colegiado: "",
  tipo_correccion: "",
  remitir_oftalmologo: false,
  // AV SC
  av_sc_lejos_d: "",
  av_sc_lejos_i: "",
  av_sc_lejos: "",
  av_sc_cerca_d: "",
  av_sc_cerca_i: "",
  av_sc_cerca: "",
  // AV CC
  av_cc_lejos_d: "",
  av_cc_lejos_i: "",
  av_cc_lejos: "",
  av_cc_cerca_d: "",
  av_cc_cerca_i: "",
  av_cc_cerca: "",
  // DIP
  nasopupilar_lejos_d: "",
  nasopupilar_lejos_i: "",
  interpupilar_lejos: "",
  nasopupilar_cerca_d: "",
  nasopupilar_cerca_i: "",
  interpupilar_cerca: "",
  // Prisma
  prisma_d: "",
  prisma_i: "",
  base_d: "",
  base_i: "",
  base_d2: "",
  base_i2: "",
  // Tonometria
  pio_hora: moment().format("HH:mm"),
  pio_d: "",
  pio_i: "",
  // Queratometría
  h_od_dp: "",
  h_od_mm: "",
  ejedh: "",
  v_od_dp: "",
  v_od_mm: "",
  ejedv: "",
  h_oi_dp: "",
  h_oi_mm: "",
  ejeih: "",
  v_oi_dp: "",
  v_oi_mm: "",
  ejeiv: "",
  // Datos
  fecha: formattedCurrentDate,
  fecha_actualizacion: formattedCurrentDate,
  fecha_revision: currentDate.add(1, "year").format("YYYY-MM-DD"),
  esquema: { lines: [], width: 450, height: 300 },
  observaciones_esquema: "",
  observaciones: "",
};

export const anamnesisStructure = {
  fecha: formattedCurrentDate,
  optometrista: "",
  sintomas_signos: "",
  gafas_graduadas_si: false,
  gafas_graduadas_no: false,
  tipo_gafa_graduadas: "",
  cristal: "",
  prisma_si: false,
  prisma_no: false,
  tipo_prisma: "",
  lentes_contacto_si: false,
  lentes_contacto_no: false,
  tipo_lentes_contacto: "",
  marca_lentes_contacto: "",
  horas_tv: "",
  horas_pc: "",
  horas_lectura: "",
  observaciones: "",
  antecedentes_familiares_si: false,
  antecedentes_familiares_no: false,
  antecedentes_familiares: "",
  patologia_ocular_si: false,
  patologia_ocular_no: false,
  patologia_ocular: "",
  tratamiento_patologia_ocular: "",
  enfermedad_sistemica_si: false,
  enfermedad_sistemica_no: false,
  enfermedad_sistemica: "",
  tratamiento_enfermedad_sistemica: "",
  diagnostico: "",
};

export const refractiveStructure = {
  fecha: formattedCurrentDate,
  optometrista: "",
  retinoscopia_esfera_od: "",
  retinoscopia_cilindro_od: "",
  retinoscopia_eje_od: "",
  retinoscopia_esfera_oi: "",
  retinoscopia_cilindro_oi: "",
  retinoscopia_eje_oi: "",
  tipo_retinoscopia: "",
  autorrefractometria_esfera_od: "",
  autorrefractometria_cilindro_od: "",
  autorrefractometria_eje_od: "",
  autorrefractometria_esfera_oi: "",
  autorrefractometria_cilindro_oi: "",
  autorrefractometria_eje_oi: "",
  observaciones_refraccion_objetiva: "",
  rx_nueva_esfera_od: "",
  rx_nueva_cilindro_od: "",
  rx_nueva_eje_od: "",
  rx_nueva_add_od: "",
  rx_nueva_esfera_oi: "",
  rx_nueva_cilindro_oi: "",
  rx_nueva_eje_oi: "",
  rx_nueva_add_oi: "",
  av_sc_od: "",
  av_sc_oi: "",
  av_sc_ao: "",
  ae_od: "",
  av_cc_od: "",
  av_cc_oi: "",
  av_cc_ao: "",
  ae_oi: "",
  filtros_polarizados_esfera_od: "",
  filtros_polarizados_cilindro_od: "",
  filtros_polarizados_eje_od: "",
  filtros_polarizados_esfera_oi: "",
  filtros_polarizados_cilindro_oi: "",
  filtros_polarizados_eje_oi: "",
  retrasado_esfera_od: "",
  retrasado_cilindro_od: "",
  retrasado_eje_od: "",
  retrasado_esfera_oi: "",
  retrasado_cilindro_oi: "",
  retrasado_eje_oi: "",
  control_convergencias_esfera_od: "",
  control_convergencias_cilindro_od: "",
  control_convergencias_eje_od: "",
  control_convergencias_esfera_oi: "",
  control_convergencias_cilindro_oi: "",
  control_convergencias_eje_oi: "",
  humphriss_esfera_od: "",
  humphriss_cilindro_od: "",
  humphriss_eje_od: "",
  humphriss_esfera_oi: "",
  humphriss_cilindro_oi: "",
  humphriss_eje_oi: "",
  observaciones_refraccion_subjetiva_binocular: "",
  diagnostico: "",
  actualizarOptometriaBasica: false,
};

export const oculomotorStructure = {
  fecha: formattedCurrentDate,
  optometrista: "",
  fijacion_si: false,
  fijacion_no: false,
  versiones_y_deducciones: -1,
  sacadicos_gran_amplitud_od: -1,
  sacadicos_gran_amplitud_oi: -1,
  tva: "",
  tva_errores: "",
  tiempo_h: "",
  error_s: "",
  error_o: "",
  error_a: "",
  error_t: "",
  tha: "",
  errores: "",
  ratio: "",
  seguimientos_od: -1,
  seguimientos_oi: -1,
  moe_filtro_rojo_diagnostico: "",
  rld: false,
  rmd: false,
  rsd: false,
  rid: false,
  oid: false,
  osd: false,
  rmi: false,
  rli: false,
  oii: false,
  osi: false,
  rsi: false,
  rii: false,
  observaciones: "",
  diagnostico: "",
};

export const binocularStructure = {
  fecha: formattedCurrentDate,
  optometrista: "",
  cover_test_cc_lejos_1: "",
  cover_test_cc_lejos_2: "",
  cover_test_cc_lejos_3: "",
  cover_test_cc_lejos_4: "",
  cover_test_cc_lejos_h: "",
  cover_test_cc_lejos_6: "",
  cover_test_cc_lejos_7: "",
  cover_test_cc_lejos_8: "",
  cover_test_cc_lejos_9: "",
  cover_test_cc_lejos_v: "",
  cover_test_sc_lejos_1: "",
  cover_test_sc_lejos_2: "",
  cover_test_sc_lejos_3: "",
  cover_test_sc_lejos_4: "",
  cover_test_sc_lejos_h: "",
  cover_test_sc_lejos_6: "",
  cover_test_sc_lejos_7: "",
  cover_test_sc_lejos_8: "",
  cover_test_sc_lejos_9: "",
  cover_test_sc_lejos_v: "",
  cover_test_cc_cerca_1: "",
  cover_test_cc_cerca_2: "",
  cover_test_cc_cerca_3: "",
  cover_test_cc_cerca_4: "",
  cover_test_cc_cerca_h: "",
  cover_test_cc_cerca_6: "",
  cover_test_cc_cerca_7: "",
  cover_test_cc_cerca_8: "",
  cover_test_cc_cerca_9: "",
  cover_test_cc_cerca_v: "",
  cover_test_sc_cerca_1: "",
  cover_test_sc_cerca_2: "",
  cover_test_sc_cerca_3: "",
  cover_test_sc_cerca_4: "",
  cover_test_sc_cerca_h: "",
  cover_test_sc_cerca_6: "",
  cover_test_sc_cerca_7: "",
  cover_test_sc_cerca_8: "",
  cover_test_sc_cerca_9: "",
  cover_test_sc_cerca_v: "",
  frecuencia: "",
  lateralidad: "",
  lateralidad_ojo: "",
  comitancia: "",
  tipo_comitancia: "",
  test_hirschberg: "",
  test_krimsky: "",
  desviacion_hor_ver_test_lejos: "",
  desviacion_hor_ver_test_cerca: "",
  desviacion_hor_ver_lejos_h: "",
  desviacion_hor_ver_cerca_h: "",
  desviacion_hor_ver_lejos_v: "",
  desviacion_hor_ver_cerca_v: "",
  disparidad_foria_test_lejos: "",
  disparidad_lejos_h: "",
  disparidad_lejos_v: "",
  foria_lejos_h: "",
  foria_lejos_v: "",
  disparidad_foria_test_cerca: "",
  disparidad_cerca_h: "",
  disparidad_cerca_v: "",
  foria_cerca_h: "",
  foria_cerca_v: "",
  ciclo_desviaciones_ojo: "",
  ciclo_desviaciones_grados: "",
  ciclo_desviaciones_tipo: "",
  vergencias: "",
  h_vfn_e_lejos: "",
  h_vfn_ro_lejos: "",
  h_vfn_re_lejos: "",
  h_vfp_e_lejos: "",
  h_vfp_ro_lejos: "",
  h_vfp_re_lejos: "",
  h_vfn_e_cerca: "",
  h_vfn_ro_cerca: "",
  h_vfn_re_cerca: "",
  h_vfp_e_cerca: "",
  h_vfp_ro_cerca: "",
  h_vfp_re_cerca: "",
  v_supra_ro_lejos: "",
  v_supra_re_lejos: "",
  v_infra_ro_lejos: "",
  v_infra_re_lejos: "",
  v_supra_ro_cerca: "",
  v_supra_re_cerca: "",
  v_infra_ro_cerca: "",
  v_infra_re_cerca: "",
  ppc_test: "",
  ppc_ro: "",
  ppc_re: "",
  flexibilidad_vergencias: "",
  criterio_sheard_vfp_e: "",
  criterio_sheard_xf: "",
  criterio_sheard_valor: "",
  criterio_percival_valor: "",
  diagnostico: "",
};

export const accommodativeStructure = {
  fecha: formattedCurrentDate,
  optometrista: "",
  amplitud_acomodacion_media: "",
  amplitud_acomodacion_minima: "",
  metodo_acercamiento_od: "",
  metodo_acercamiento_oi: "",
  metodo_lentes_negativas_od: "",
  metodo_lentes_negativas_oi: "",
  fab: "",
  famod: "",
  famoi: "",
  arn: "",
  arp: "",
  memod: "",
  memoi: "",
  nottod: "",
  nottoi: "",
  ccf: "",
  cr: "",
  fl: "",
  fc: "",
  heteroforia: "",
  fhvp: "",
  fivp: "",
  l: "",
  gradiente: "",
  ada: "",
  ava: "",
  observaciones: "",
  diagnostico: "",
};

export const sensoryStructure = {
  fecha: formattedCurrentDate,
  optometrista: "",
  test_worth_lejos: -1,
  test_worth_cerca: -1,
  observaciones_test_worth_lejos: "",
  observaciones_test_worth_cerca: "",
  filtro_rojo_lejos: "",
  filtro_rojo_cerca: "",
  bagolini_lejos: "",
  bagolini_cerca: "",
  test_ishihara: "",
  test_farnsworth: "",
  hess_lancaster: "",
  prisma_4a: "",
  estereopsis: "",
  valor_estereopsis: "",
  observaciones_estereopsis: "",
  rejilla_amsler: "",
  sensibilidad_contraste: "",
  diagnostico: "",
};

export const audiometryStructure = {
  fecha: formattedCurrentDate,
  audioprotesista: "",
  audifonos: "",
  sintomas: "",
  patologias: "",
  tratamientos: "",
  antecedentes: "",
  dolor: false,
  perdida_progresiva: false,
  trabajo_ruidoso: false,
  vertigo: false,
  sensible_ruidos: false,
  tapones: "",
  perforacion: "",
  otorrea: "",
  dominancia_auditiva: "",
  acufenos: "",
  volumen_tv: "",
  telefono: "",
  sonidos_agudos: "",
  sonidos_graves: "",
  sonido_ambiental: "",
  eventos_publicos_cerrados: "",
  eventos_publicos_abiertos: "",
  conv_individual_sr: "",
  conv_individual_cr: "",
  conv_grupo_sr: "",
  conv_grupo_cr: "",
  aerea_d_125: "",
  aerea_d_250: "",
  aerea_d_500: "",
  aerea_d_1000: "",
  aerea_d_1500: "",
  aerea_d_2000: "",
  aerea_d_3000: "",
  aerea_d_4000: "",
  aerea_d_6000: "",
  aerea_d_8000: "",
  osea_d_125: "",
  osea_d_250: "",
  osea_d_500: "",
  osea_d_1000: "",
  osea_d_1500: "",
  osea_d_2000: "",
  osea_d_3000: "",
  osea_d_4000: "",
  osea_d_6000: "",
  osea_d_8000: "",
  aerea_i_125: "",
  aerea_i_250: "",
  aerea_i_500: "",
  aerea_i_1000: "",
  aerea_i_1500: "",
  aerea_i_2000: "",
  aerea_i_3000: "",
  aerea_i_4000: "",
  aerea_i_6000: "",
  aerea_i_8000: "",
  osea_i_125: "",
  osea_i_250: "",
  osea_i_500: "",
  osea_i_1000: "",
  osea_i_1500: "",
  osea_i_2000: "",
  osea_i_3000: "",
  osea_i_4000: "",
  osea_i_6000: "",
  osea_i_8000: "",
  umbral_d_125: "",
  umbral_d_250: "",
  umbral_d_500: "",
  umbral_d_1000: "",
  umbral_d_1500: "",
  umbral_d_2000: "",
  umbral_d_3000: "",
  umbral_d_4000: "",
  umbral_d_6000: "",
  umbral_d_8000: "",
  umbral_i_125: "",
  umbral_i_250: "",
  umbral_i_500: "",
  umbral_i_1000: "",
  umbral_i_1500: "",
  umbral_i_2000: "",
  umbral_i_3000: "",
  umbral_i_4000: "",
  umbral_i_6000: "",
  umbral_i_8000: "",
  weber_128: "",
  weber_256: "",
  weber_512: "",
  weber_1024: "",
  weber_2048: "",
  rinne_128: "",
  rinne_256: "",
  rinne_512: "",
  rinne_1024: "",
  rinne_2048: "",
  timpanometria_d: "",
  timpanometria_i: "",
  fecha_revision: moment().format("YYYY-MM-DD"),
  observaciones: "",
  optica_alta: "",
  fecha_actualizacion: formattedCurrentDate,
};

export const glassesStructure = {
  idFichaGafas: "",
  idFicha: "",
  gafasSol: false,
  fechaCreacion: "",
  fechaEntrega: "",
  fechaRevision: "",
  fechaActualizacion: "",
  empleado: "",
  tipoFicha: "",
  tipoGafa: "",
  gama: "",
  premontada: false,
  motivoAgente: "",
  pvptotal: 0,
  dtoTotal: 0,
  precioTotal: 0,
  vendida: false,
  datosMontura: {
    codigo: "",
    marca: "",
    modelo: "",
    color: "",
    colorCristal: "",
    nombreProveedor: "",
    idProveedor: "",
    refProveedor: "",
    calibre1: "",
    calibre2: "",
    material: "",
    forma: "",
    varilla: "",
    genero: "",
    pvp: 0,
    descuento: 0,
    total: 0,
  },
  datosLenteOD: {
    codigo: "",
    nombreProveedor: "",
    idProveedor: "",
    marca: "",
    nombreComercial: "",
    material: "",
    color: "",
    tratamiento: "",
    tipo: "",
    disponibilidad: "",
    esf: "",
    cil: "",
    eje: "",
    add: "",
    totalLente: "",
    ind: "",
    dia: "",
    alt: "",
    desc: "",
    pvp: 0,
    descuento: 0,
    total: 0,
    pvpTratamiento: 0,
    descuentoTratamiento: 0,
    totalTratamiento: 0,
  },
  datosLenteOI: {
    codigo: "",
    nombreProveedor: "",
    idProveedor: "",
    marca: "",
    nombreComercial: "",
    material: "",
    color: "",
    tratamiento: "",
    tipo: "",
    disponibilidad: "",
    esf: "",
    cil: "",
    eje: "",
    add: "",
    totalLente: "",
    ind: "",
    dia: "",
    alt: "",
    desc: "",
    pvp: 0,
    descuento: 0,
    total: 0,
    pvpTratamiento: 0,
    descuentoTratamiento: 0,
    totalTratamiento: 0,
  },
};

export const contactLensRecordStructure = {
  idFichaLentillas: "",
  idFicha: "",
  fechaCreacion: "",
  fechaEntrega: "",
  fechaRevision: "",
  fechaActualizacion: "",
  empleado: "",
  tipoFicha: "",
  motivoAgente: "",
  pvptotal: 0,
  dtoTotal: 0,
  precioTotal: 0,
  vendida: false,
  datosLentillaOD: {
    codigo: "",
    proveedor: "",
    idProveedor: "",
    marca: "",
    nombreComercial: "",
    tipo: "",
    desechable: false,
    uso: "",
    color: "",
    unidades: 0,
    esf: "",
    cil: "",
    eje: "",
    add: "",
    total: "",
    rad: "",
    rad2: "",
    dia: "",
    avcc: "",
    ao: "",
    pvp: 0,
    descuento: 0,
    pack: 1,
    totalPrecio: 0,
  },
  datosLentillaOI: {
    codigo: "",
    proveedor: "",
    idProveedor: "",
    marca: "",
    nombreComercial: "",
    tipo: "",
    desechable: false,
    uso: "",
    color: "",
    unidades: 0,
    esf: "",
    cil: "",
    eje: "",
    add: "",
    total: "",
    rad: "",
    rad2: "",
    dia: "",
    avcc: "",
    ao: "",
    pvp: 0,
    descuento: 0,
    pack: 1,
    totalPrecio: 0,
  },
  liquido: {
    codigo: "",
    nombreProveedor: "",
    idProveedor: "",
    marca: "",
    nombreComercial: "",
    capacidad: "",
    pvp: 0,
    descuento: 0,
    pack: 1,
    total: 0,
  },
};

export const contactLensesTestStructure = {
  idFichaLentillasPruebas: "",
  idFichaLentillas: "",
  fechaCreacion: "",
  fechaActualizacion: "",
  empleado: "",
  horasUso: "",
  datosLentillaOD: {
    codigo: "",
    nombreComercial: "",
    esf: "",
    cil: "",
    eje: "",
    add: "",
    rad: "",
    rad2: "",
    dia: "",
    observaciones: "",
  },
  datosLentillaOI: {
    codigo: "",
    nombreComercial: "",
    esf: "",
    cil: "",
    eje: "",
    add: "",
    rad: "",
    rad2: "",
    dia: "",
    observaciones: "",
  },
  otros: {
    movimientoOD: "",
    movimientoOI: "",
    centradoOD: "",
    centradoOI: "",
    girosOD: "",
    tipoGiroOD: "",
    girosOI: "",
    tipoGirosOI: "",
    fluorogramaOD: "",
    fluorogramaOI: "",
    comodidadOD: "",
    comodidadOI: "",
  },
  AVSC: {
    VLOD: "",
    VLOI: "",
    VLAO: "",
    VPOD: "",
    VPOI: "",
    VPAO: "",
  },
  AVCC: {
    VLOD: "",
    VLOI: "",
    VLAO: "",
    VPOD: "",
    VPOI: "",
    VPAO: "",
  },
  AVSRX: {
    VLOD: "",
    VLOI: "",
    VLAO: "",
    VPOD: "",
    VPOI: "",
    VPAO: "",
  },
  RX: {
    esferaOD: "",
    cilindroOD: "",
    ejeOD: "",
    addOD: "",
    esferaOI: "",
    cilindroOI: "",
    ejeOI: "",
    addOI: "",
  },
  AVCC2: {
    VLOD: "",
    VLOI: "",
    VLAO: "",
    VPOD: "",
    VPOI: "",
    VPAO: "",
  },
  SRX: {
    esferaOD: "",
    cilindroOD: "",
    ejeOD: "",
    esferaOI: "",
    cilindroOI: "",
    ejeOI: "",
  },
};

export const hearingAidRecordStructure = {
  idFichaAudifono: "",
  idFicha: "",
  fechaCreacion: "",
  fechaEntrega: "",
  fechaRevision: "",
  fechaActualizacion: "",
  empleado: "",
  tipoFicha: "",
  motivoAgente: "",
  pvptotal: "",
  dtoTotal: "",
  precioTotal: "",
  vendida: false,
  datosAudifonoD: {
    codigo: "",
    proveedor: "",
    idProveedor: "",
    nSerie: "",
    marca: "",
    modelo: "",
    tipo: "",
    entreDb: "",
    hastaDb: "",
    codigoAuricular: "",
    idProveedorAuricular: "",
    nombreProveedorAuricular: "",
    auricular: "",
    codigoPila: "",
    idProveedorPila: "",
    nombreProveedorPila: "",
    pila: "",
    pvp: 0.0,
    descuento: 0.0,
    total: 0.0,
  },
  datosAudifonoI: {
    codigo: "",
    proveedor: "",
    idProveedor: "",
    nSerie: "",
    marca: "",
    modelo: "",
    tipo: "",
    entreDb: "",
    hastaDb: "",
    codigoAuricular: "",
    idProveedorAuricular: "",
    nombreProveedorAuricular: "",
    auricular: "",
    codigoPila: "",
    idProveedorPila: "",
    nombreProveedorPila: "",
    pila: "",
    pvp: 0.0,
    descuento: 0.0,
    total: 0.0,
  },
  cargador: {
    codigo: "",
    nombreProveedor: "",
    idProveedor: "",
    marca: "",
    modelo: "",
    pvp: 0.0,
    descuento: 0.0,
    total: 0.0,
  },
};

export const deviationFactor = 5;

// Lleva la desviación añadida para que cuadre en la rejilla.
export const hessLancasterStructure = {
  idHessLancaster: -1,
  punto1_od_x: 81 + deviationFactor,
  punto1_od_y: 81 + deviationFactor,
  punto2_od_x: 195 + deviationFactor,
  punto2_od_y: 81 + deviationFactor,
  punto3_od_x: 309 + deviationFactor,
  punto3_od_y: 81 + deviationFactor,
  punto4_od_x: 81 + deviationFactor,
  punto4_od_y: 195 + deviationFactor,
  punto5_od_x: 195 + deviationFactor,
  punto5_od_y: 195 + deviationFactor,
  punto6_od_x: 309 + deviationFactor,
  punto6_od_y: 195 + deviationFactor,
  punto7_od_x: 81 + deviationFactor,
  punto7_od_y: 309 + deviationFactor,
  punto8_od_x: 195 + deviationFactor,
  punto8_od_y: 309 + deviationFactor,
  punto9_od_x: 309 + deviationFactor,
  punto9_od_y: 309 + deviationFactor,
  observaciones_od: "",
  punto1_oi_x: 81 + deviationFactor,
  punto1_oi_y: 81 + deviationFactor,
  punto2_oi_x: 195 + deviationFactor,
  punto2_oi_y: 81 + deviationFactor,
  punto3_oi_x: 309 + deviationFactor,
  punto3_oi_y: 81 + deviationFactor,
  punto4_oi_x: 81 + deviationFactor,
  punto4_oi_y: 195 + deviationFactor,
  punto5_oi_x: 195 + deviationFactor,
  punto5_oi_y: 195 + deviationFactor,
  punto6_oi_x: 309 + deviationFactor,
  punto6_oi_y: 195 + deviationFactor,
  punto7_oi_x: 81 + deviationFactor,
  punto7_oi_y: 309 + deviationFactor,
  punto8_oi_x: 195 + deviationFactor,
  punto8_oi_y: 309 + deviationFactor,
  punto9_oi_x: 309 + deviationFactor,
  punto9_oi_y: 309 + deviationFactor,
  observaciones_oi: "",
};

export const eyeHealthStructure = {
  fecha: formattedCurrentDate,
  optometrista: "",
  papila_od: "",
  papila_oi: "",
  vasos_od: "",
  vasos_oi: "",
  retina_od: "",
  retina_oi: "",
  macula_od: "",
  macula_oi: "",
  fijacion_od: "",
  fijacion_oi: "",
  otros_oftalmoscopia_od: "",
  otros_oftalmoscopia_oi: "",
  parpados_od: "",
  parpados_oi: "",
  pestanias_od: "",
  pestanias_oi: "",
  conjuntiva_od: "",
  conjuntiva_oi: "",
  cornea_od: "",
  cornea_oi: "",
  iris_od: "",
  iris_oi: "",
  cristalino_od: "",
  cristalino_oi: "",
  otros_bio_od: "",
  otros_bio_oi: "",
  tamanio_pupilar: "",
  reaccion_pupilar_luz: "",
  respuesta_al_acercamiento: "",
  otros_pirla: "",
  campimetria: "",
  confrontacion_de_campos: "",
  pantalla_tangente: "",
  diagnostico: "",
};

export const previousRXData = {
  esfera_d: "",
  esfera_i: "",
  cilindro_d: "",
  cilindro_i: "",
  eje_d: "",
  eje_i: "",
  adicion_d: "",
  adicion_i: "",
  intermedia_d: "",
  intermedia_i: "",
  cerca_d: "",
  cerca_i: "",
  total_d: "",
  total_i: "",
  optometrista: "",
  oftalmologo: "",
};

export const CORRECCIONLIST = [
  { id: "", text: "" },
  { id: "BIFOCAL", text: "BIFOCAL" },
  { id: "MONOFOCAL", text: "MONOFOCAL" },
  { id: "PROGRESIVO", text: "PROGRESIVO" },
];

export const BASELIST = [
  { id: "", text: "" },
  { id: "INFERIOR", text: "INFERIOR" },
  { id: "NASAL", text: "NASAL" },
  { id: "SUPERIOR", text: "SUPERIOR" },
  { id: "TEMPORAL", text: "TEMPORAL" },
];

export const PRISMALIST = [
  { id: "", text: "" },
  { id: "FRESNEL", text: "FRESNEL" },
  { id: "TALLADO EN GAFA", text: "TALLADO EN GAFA" },
];

export const RETINOSCOPYLIST = [
  { id: "", text: "" },
  { id: "RETINOSCOPÍA ESTÁTICA", text: "RETINOSCOPÍA ESTÁTICA" },
  { id: "RETINOSCOPÍA DE MOHINDRA", text: "RETINOSCOPÍA DE MOHINDRA" },
];

export const MOELIST = [
  { id: "", text: "" },
  {
    id: "DESVIACION VERTICAL DISOCIADA (DVD)",
    text: "DESVIACION VERTICAL DISOCIADA (DVD)",
  },
  { id: "OFTALMOPLEGIA INTERNUCLEAR", text: "OFTALMOPLEGIA INTERNUCLEAR" },
  { id: "PARALISIS BILATERAL IV PAR", text: "PARALISIS BILATERAL IV PAR" },
  { id: "PARALISIS III PAR", text: "PARALISIS III PAR" },
  { id: "PARALISIS OI", text: "PARALISIS OI" },
  { id: "PARALISIS OS", text: "PARALISIS OS" },
  { id: "PARALISIS OS", text: "PARALISIS OS" },
  { id: "PARALISIS RI", text: "PARALISIS RI" },
  { id: "PARALISIS RS", text: "PARALISIS RS" },
  { id: "SINDROME DE BROWN", text: "SINDROME DE BROWN" },
  { id: "SINDROME DE DUANE", text: "SINDROME DE DUANE" },
  { id: "SINDROME DE PARINAUD", text: "SINDROME DE PARINAUD" },
  { id: "SINDROME DEL UNO Y MEDIO", text: "SINDROME DEL UNO Y MEDIO" },
];

export const FREQUENCYLIST = [
  { id: "", text: "" },
  { id: "CONSTANTE", text: "CONSTANTE" },
  { id: "INTERMITENTE", text: "INTERMITENTE" },
];

export const LATERALITYLIST = [
  { id: "", text: "" },
  { id: "ALTERNANTE", text: "ALTERNANTE" },
  { id: "UNILATERAL", text: "UNILATERAL" },
];

export const EYELIST = [
  { id: "", text: "" },
  { id: "OD", text: "OD" },
  { id: "OI", text: "OI" },
];

export const COMITANCELIST = [
  { id: "", text: "" },
  { id: "COMITANTE", text: "COMITANTE" },
  { id: "INCOMITANTE", text: "INCOMITANTE" },
];

export const COMITANCETYPELIST = [
  { id: "", text: "" },
  { id: "A", text: "A" },
  { id: "V", text: "V" },
  { id: "X", text: "X" },
  { id: "Y", text: "Y" },
  { id: "λ", text: "λ" },
];

export const VERGENCELIST = [
  { id: "", text: "" },
  { id: "BARRA DE PRISMAS", text: "BARRA DE PRISMAS" },
  { id: "DIASPORAMETRO", text: "DIASPORAMETRO" },
];

export const SUBJETIVEDESVIATIONLIST = [
  { id: "", text: "" },
  { id: "BARRA DE PRISMAS", text: "BARRA DE PRISMAS" },
  { id: "DIASPORAMETRO (VON GRAEFE)", text: "DIASPORAMETRO (VON GRAEFE)" },
  { id: "TEST DE SCHÖBER", text: "TEST DE SCHÖBER" },
  { id: "THORINGTON MODIFICADO", text: "THORINGTON MODIFICADO" },
  { id: "VARILLA DE MADDOX", text: "VARILLA DE MADDOX" },
];

export const DISPARITYFARLIST = [
  { id: "", text: "" },
  { id: "BERNELL", text: "BERNELL" },
  { id: "OXO", text: "OXO" },
];

export const DISPARITYNEARLIST = [
  { id: "", text: "" },
  { id: "BERNELL", text: "BERNELL" },
  { id: "MALLET", text: "MALLET" },
  { id: "OXO", text: "OXO" },
  { id: "WESSON", text: "WESSON" },
];

export const CYCLODEVLIST = [
  { id: "", text: "" },
  { id: "EXCICLO", text: "EXCICLO" },
  { id: "INCICLO", text: "INCICLO" },
];

export const PPCLIST = [
  { id: "", text: "" },
  { id: "ESTIMULO ACOMODATIVO", text: "ESTIMULO ACOMODATIVO" },
  { id: "LUZ PUNTUAL", text: "LUZ PUNTUAL" },
  { id: "LUZ PUNTUAL + FILTRO ROJO", text: "LUZ PUNTUAL + FILTRO ROJO" },
];

export const HESSLANCASTERLIST = [
  { id: "", text: "" },
  { id: "PARÁLISIS O PARESIA OI OD", text: "PARÁLISIS O PARESIA OI OD" },
  { id: "PARÁLISIS O PARESIA OI OI", text: "PARÁLISIS O PARESIA OI OI" },
  { id: "PARÁLISIS O PARESIA OS OD", text: "PARÁLISIS O PARESIA OS OD" },
  { id: "PARÁLISIS O PARESIA OS OI", text: "PARÁLISIS O PARESIA OS OI" },
  { id: "PARÁLISIS O PARESIA RI OD", text: "PARÁLISIS O PARESIA RI OD" },
  { id: "PARÁLISIS O PARESIA RI OI", text: "PARÁLISIS O PARESIA RI OI" },
  { id: "PARÁLISIS O PARESIA RL OD", text: "PARÁLISIS O PARESIA RL OD" },
  { id: "PARÁLISIS O PARESIA RL OI", text: "PARÁLISIS O PARESIA RL OI" },
  { id: "PARÁLISIS O PARESIA RM OD", text: "PARÁLISIS O PARESIA RM OD" },
  { id: "PARÁLISIS O PARESIA RM OI", text: "PARÁLISIS O PARESIA RM OI" },
  { id: "PARÁLISIS O PARESIA RS OD", text: "PARÁLISIS O PARESIA RS OD" },
  { id: "PARÁLISIS O PARESIA RS OI", text: "PARÁLISIS O PARESIA RS OI" },
];

export const STEREOPSISLIST = [
  { id: "", text: "" },
  { id: "FRISBY", text: "FRISBY" },
  { id: "LANG", text: "LANG" },
  { id: "RANDOT", text: "RANDOT" },
  { id: "TIMUS", text: "TITMUS" },
  { id: "TNO", text: "TNO" },
];

export const ACUFENOSLIST = [
  { id: "", text: "" },
  { id: "A", text: "AMBOS" },
  { id: "D", text: "OD" },
  { id: "I", text: "OI" },
  { id: "N", text: "NO" },
];

export const OTORREALIST = [
  { id: "", text: "" },
  { id: "A", text: "AMBOS" },
  { id: "D", text: "OD" },
  { id: "I", text: "OI" },
  { id: "N", text: "NO" },
];

export const PERFORACIONLIST = [
  { id: "", text: "" },
  { id: "A", text: "AMBOS" },
  { id: "D", text: "OD" },
  { id: "I", text: "OI" },
  { id: "N", text: "NO" },
];

export const DOMINANCIALIST = [
  { id: "", text: "" },
  { id: "A", text: "IGUAL" },
  { id: "D", text: "OD" },
  { id: "I", text: "OI" },
];

export const TAPONESLIST = [
  { id: "", text: "" },
  { id: "A", text: "AMBOS" },
  { id: "D", text: "OD" },
  { id: "I", text: "OI" },
  { id: "N", text: "NO" },
  { id: "PR", text: "PROPENSO" },
];

export const VOLUMENTVLIST = [
  { id: "", text: "" },
  { id: "A", text: "ALTO" },
  { id: "B", text: "BAJO" },
  { id: "M", text: "MEDIO" },
];

export const CONVERSACIONTLFLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const SONIDOSAGUDOSLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const SONIDOSGRAVESLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const SONIDOAMBIENTELIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const EVENTOSPUBLICOSCERRADOSLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const EVENTOSPUBLICOSABIERTOSLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const CONVERSACIONINDIVIDUALLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const CONVERSACIONINDIVIDUALRUIDOLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const CONVERSACIONENGRUPOLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const CONVERSACIONENGRUPORUIDOLIST = [
  { id: "", text: "" },
  { id: "B", text: "BUENA" },
  { id: "M", text: "MALA" },
  { id: "R", text: "REGULAR" },
];

export const TESTDEWEBERLIST = [
  { id: "", text: "" },
  { id: "A", text: "AMBOS" },
  { id: "D", text: "OD" },
  { id: "I", text: "OI" },
];

export const TESTDERINNELIST = [
  { id: "", text: "" },
  { id: "A", text: "AÉREA" },
  { id: "O", text: "ÓSEA" },
];

export const TIMPANOMETRIALIST = [
  { id: "", text: "" },
  { id: "A", text: "NORMAL" },
  { id: "B", text: "PLANA" },
  { id: "C", text: "PRESIONES NEGATIVAS" },
  { id: "As", text: "COMPLIANCIA REDUCIDA" },
  { id: "Ad", text: "HIPERCOMPLIANCIA" },
];

export const testScheme = { lines: [], width: 450, height: 300 };

export const initialAudiometryPoints = [
  { x: 125, y: 0 },
  { x: 250, y: 0 },
  { x: 500, y: 0 },
  { x: 1000, y: 0 },
  { x: 1500, y: 0 },
  { x: 2000, y: 0 },
  { x: 3000, y: 0 },
  { x: 4000, y: 0 },
  { x: 6000, y: 0 },
  { x: 8000, y: 0 },
];

export const gridXValues = [
  125, 250, 500, 1000, 1500, 2000, 3000, 4000, 6000, 8000,
];
export const gridYValues = [
  -120, -110, -100, -90, -80, -70, -60, -50, -40, -30, -20, -10, 0, 10, 20,
];

export const supplierStructure = {
  id: -1,
  nif: "",
  empresa: "",
  responsable: "",
  contacto: "",
  direccion: "",
  cp: "",
  localidad: "",
  provincia: "",
  telefono1: "",
  telefono2: "",
  movil1: "",
  movil2: "",
  whatsapp: "",
  email1: "",
  email2: "",
  web: "",
  actualizacion: formattedCurrentDate,
  codigoFacturacion: "",
  codigoEnvio: "",
  codigoCliente: "",
  notas: "",
  audifonos: false,
  descuentoAudifonos: "",
  cristales: false,
  descuentoCristales: "",
  lentillas: false,
  descuentoLentillas: "",
  liquidos: false,
  descuentoLiquidos: "",
  monturas: false,
  descuentoMonturas: "",
  varios: false,
  descuentoVarios: "",
  gafas: false,
  descuentoGafas: "",
};

export const hearingAidsTypeOptions = [
  {
    id: "",
    text: "",
  },
  {
    id: "CIC",
    text: "CIC",
  },
  {
    id: "INTRA",
    text: "INTRA",
  },
  {
    id: "MINI RITE",
    text: "MINI RITE",
  },
  {
    id: "RETRO",
    text: "RETRO",
  },
];

export const contactLensesUseOptions = [
  {
    id: "",
    text: "",
  },
  {
    id: "ANUAL",
    text: "ANUAL",
  },
  {
    id: "DIARIA",
    text: "DIARIA",
  },
  {
    id: "MENSUAL",
    text: "MENSUAL",
  },
  {
    id: "QUINCENAL",
    text: "QUINCENAL",
  },
  {
    id: "SEMANAL",
    text: "SEMANAL",
  },
  {
    id: "SEMESTRAL",
    text: "SEMESTRAL",
  },
  {
    id: "TRIMESTRAL",
    text: "TRIMESTRAL",
  },
];

export const genderProductOptions = [
  {
    id: "",
    text: "",
  },
  {
    id: "HOMBRE",
    text: "HOMBRE",
  },
  {
    id: "MUJER",
    text: "MUJER",
  },
  {
    id: "UNISEX",
    text: "UNISEX",
  },
];

export const availabilityProductOptions = [
  {
    id: "",
    text: "",
  },
  {
    id: "RX",
    text: "RX",
  },
  {
    id: "STOCK",
    text: "STOCK",
  },
];

export const hearingAidsStructure = {
  id: -1,
  fechaAlta: "",
  fechaUltimaCompra: "",
  fechaUltimaVenta: "",
  fechaLimite: "",
  codigoOPTIWIN: "",
  codigoEANUPC: "",
  nombreProveedor: "",
  idProveedor: -1,
  marca: "",
  modelo: "",
  tipo: "",
  entreDB: "",
  hastaDB: "",
  numeroSerie: "",
  referenciaProveedor: "",
  etiquetado: "",
  observaciones: "",
  pvp: 0,
  iva: "",
  pvpRecomendado: "",
  fechaOfertaInicio: "",
  fechaOfertaFin: "",
  pvpOferta: "",
  unidadesPvpEspecial: 0,
  pvpEspecial: "",
  pmc: "",
  pmv: "",
  pcn: "",
  pcb: "",
  stock: 0,
  margenComercial: "",
  comision: "",
  dtoMaximo: "",
  stockMinimo: "",
  descatalogado: false,
  sinControlStock: false,
};

export const lensesStructure = {
  id: -1,
  fechaAlta: "",
  fechaUltimaCompra: "",
  fechaUltimaVenta: "",
  fechaLimite: "",
  codigoOPTIWIN: "",
  codigoEANUPC: "",
  nombreProveedor: "",
  idProveedor: -1,
  marca: "",
  nombreComercial: "",
  material: "",
  tipo: "",
  color: "",
  disponibilidad: "",
  tratamiento: "",
  referenciaProveedor: "",
  etiquetado: "",
  observaciones: "",
  eje: "",
  cil: "",
  esf: "",
  add: "",
  total: "",
  ind: "",
  dia: "",
  den: "",
  abbe: "",
  pvp: 0,
  iva: "",
  pvpRecomendado: "",
  fechaOfertaInicio: "",
  fechaOfertaFin: "",
  pvpOferta: "",
  unidadesPvpEspecial: 0,
  pvpEspecial: "",
  pmc: "",
  pmv: "",
  pcn: "",
  pcb: "",
  stock: 0,
  margenComercial: "",
  comision: "",
  dtoMaximo: "",
  stockMinimo: "",
  descatalogado: false,
  sinControlStock: false,
};

export const contactLensesStructure = {
  id: -1,
  fechaAlta: "",
  fechaUltimaCompra: "",
  fechaUltimaVenta: "",
  fechaLimite: "",
  codigoOPTIWIN: "",
  codigoEANUPC: "",
  nombreProveedor: "",
  idProveedor: -1,
  marca: "",
  nombreComercial: "",
  tipo: "",
  desechable: false,
  uso: "",
  color: "",
  unidades: "",
  referenciaProveedor: "",
  etiquetado: "",
  observaciones: "",
  eje: "",
  cil: "",
  esf: "",
  add: "",
  total: "",
  rad1: "",
  rad2: "",
  dia: "",
  hid: "",
  zo: "",
  ela: "",
  pvp: 0,
  iva: "",
  pvpRecomendado: "",
  fechaOfertaInicio: "",
  fechaOfertaFin: "",
  pvpOferta: "",
  unidadesPvpEspecial: 0,
  pvpEspecial: "",
  pmc: "",
  pmv: "",
  pcn: "",
  pcb: "",
  stock: 0,
  margenComercial: "",
  comision: "",
  dtoMaximo: "",
  stockMinimo: "",
  descatalogado: false,
  sinControlStock: false,
};

export const liquidStructure = {
  id: -1,
  fechaAlta: "",
  fechaUltimaCompra: "",
  fechaUltimaVenta: "",
  fechaLimite: "",
  codigoOPTIWIN: "",
  codigoEANUPC: "",
  nombreProveedor: "",
  idProveedor: -1,
  marca: "",
  nombreComercial: "",
  capacidad: "",
  referenciaProveedor: "",
  etiquetado: "",
  observaciones: "",
  pvp: 0,
  iva: "",
  pvpRecomendado: "",
  fechaOfertaInicio: "",
  fechaOfertaFin: "",
  pvpOferta: "",
  unidadesPvpEspecial: 0,
  pvpEspecial: "",
  pmc: "",
  pmv: "",
  pcn: "",
  pcb: "",
  stock: 0,
  margenComercial: "",
  comision: "",
  dtoMaximo: "",
  stockMinimo: "",
  descatalogado: false,
  sinControlStock: false,
};

export const frameStructure = {
  id: -1,
  fechaAlta: "",
  fechaUltimaCompra: "",
  fechaUltimaVenta: "",
  fechaLimite: "",
  codigoOPTIWIN: "",
  codigoEANUPC: "",
  nombreProveedor: "",
  idProveedor: -1,
  marca: "",
  modelo: "",
  color: "",
  calibre: "",
  puente: "",
  varilla: "",
  material: "",
  genero: "",
  forma: "",
  referenciaProveedor: "",
  etiquetado: "",
  observaciones: "",
  pvp: 0,
  iva: "",
  pvpRecomendado: "",
  fechaOfertaInicio: "",
  fechaOfertaFin: "",
  pvpOferta: "",
  unidadesPvpEspecial: 0,
  pvpEspecial: "",
  pmc: "",
  pmv: "",
  pcn: "",
  pcb: "",
  stock: 0,
  margenComercial: "",
  comision: "",
  dtoMaximo: "",
  stockMinimo: "",
  descatalogado: false,
  sinControlStock: false,
};

export const variousStructure = {
  id: -1,
  fechaAlta: "",
  fechaUltimaCompra: "",
  fechaUltimaVenta: "",
  fechaLimite: "",
  codigoOPTIWIN: "",
  codigoEANUPC: "",
  nombreProveedor: "",
  idProveedor: -1,
  marca: "",
  producto: "",
  subtipo: "",
  referenciaProveedor: "",
  etiquetado: "",
  observaciones: "",
  pvp: 0,
  iva: "",
  pvpRecomendado: "",
  fechaOfertaInicio: "",
  fechaOfertaFin: "",
  pvpOferta: "",
  unidadesPvpEspecial: 0,
  pvpEspecial: "",
  pmc: "",
  pmv: "",
  pcn: "",
  pcb: "",
  stock: 0,
  margenComercial: "",
  comision: "",
  dtoMaximo: "",
  stockMinimo: "",
  descatalogado: false,
  sinControlStock: false,
};

export const sunglassesStructure = {
  id: -1,
  fechaAlta: "",
  fechaUltimaCompra: "",
  fechaUltimaVenta: "",
  fechaLimite: "",
  codigoOPTIWIN: "",
  codigoEANUPC: "",
  nombreProveedor: "",
  idProveedor: -1,
  marca: "",
  modelo: "",
  color: "",
  forma: "",
  colorCristal: "",
  calibre: "",
  puente: "",
  varilla: "",
  material: "",
  genero: "",
  referenciaProveedor: "",
  etiquetado: "",
  observaciones: "",
  pvp: 0,
  iva: "",
  pvpRecomendado: "",
  fechaOfertaInicio: "",
  fechaOfertaFin: "",
  pvpOferta: "",
  unidadesPvpEspecial: "",
  pvpEspecial: "",
  pmc: "",
  pmv: "",
  pcn: "",
  pcb: "",
  stock: 0,
  margenComercial: "",
  comision: "",
  dtoMaximo: "",
  stockMinimo: "",
  descatalogado: false,
  sinControlStock: false,
};

export const deliveryNoteElements = [
  {
    id: 0,
    fechaAlbaran: "16/09/2024",
    proveedor: "PROVEEDOR 1",
    numeroAlbaran: "A001",
    unidades: 10,
    base: "1000.00",
    iva: "210.00",
    total: "1210.00",
    agente: "AGENTE 1",
  },
  {
    id: 1,
    fechaAlbaran: "17/09/2024",
    proveedor: "PROVEEDOR 2",
    numeroAlbaran: "A002",
    unidades: 8,
    base: "800.00",
    iva: "168.00",
    total: "968.00",
    agente: "AGENTE 2",
  },
  {
    id: 2,
    fechaAlbaran: "18/09/2024",
    proveedor: "PROVEEDOR 3",
    numeroAlbaran: "A003",
    unidades: 15,
    base: "1500.00",
    iva: "315.00",
    total: "1815.00",
    agente: "AGENTE 3",
  },
  {
    id: 3,
    fechaAlbaran: "19/09/2024",
    proveedor: "PROVEEDOR 4",
    numeroAlbaran: "A004",
    unidades: 12,
    base: "1200.00",
    iva: "252.00",
    total: "1452.00",
    agente: "AGENTE 4",
  },
  {
    id: 4,
    fechaAlbaran: "20/09/2024",
    proveedor: "PROVEEDOR 5",
    numeroAlbaran: "A005",
    unidades: 20,
    base: "2000.00",
    iva: "420.00",
    total: "2420.00",
    agente: "AGENTE 5",
  },
  {
    id: 5,
    fechaAlbaran: "21/09/2024",
    proveedor: "PROVEEDOR 6",
    numeroAlbaran: "A006",
    unidades: 5,
    base: "500.00",
    iva: "105.00",
    total: "605.00",
    agente: "AGENTE 6",
  },
  {
    id: 6,
    fechaAlbaran: "22/09/2024",
    proveedor: "PROVEEDOR 7",
    numeroAlbaran: "A007",
    unidades: 18,
    base: "1800.00",
    iva: "378.00",
    total: "2178.00",
    agente: "AGENTE 7",
  },
  {
    id: 7,
    fechaAlbaran: "23/09/2024",
    proveedor: "PROVEEDOR 8",
    numeroAlbaran: "A008",
    unidades: 25,
    base: "2500.00",
    iva: "525.00",
    total: "3025.00",
    agente: "AGENTE 8",
  },
  {
    id: 8,
    fechaAlbaran: "24/09/2024",
    proveedor: "PROVEEDOR 9",
    numeroAlbaran: "A009",
    unidades: 14,
    base: "1400.00",
    iva: "294.00",
    total: "1694.00",
    agente: "AGENTE 9",
  },
  {
    id: 9,
    fechaAlbaran: "25/09/2024",
    proveedor: "PROVEEDOR 10",
    numeroAlbaran: "A010",
    unidades: 30,
    base: "3000.00",
    iva: "630.00",
    total: "3630.00",
    agente: "AGENTE 10",
  },
  {
    id: 10,
    fechaAlbaran: "26/09/2024",
    proveedor: "PROVEEDOR 11",
    numeroAlbaran: "A011",
    unidades: 6,
    base: "600.00",
    iva: "126.00",
    total: "726.00",
    agente: "AGENTE 11",
  },
  {
    id: 11,
    fechaAlbaran: "27/09/2024",
    proveedor: "PROVEEDOR 12",
    numeroAlbaran: "A012",
    unidades: 7,
    base: "700.00",
    iva: "147.00",
    total: "847.00",
    agente: "AGENTE 12",
  },
  {
    id: 12,
    fechaAlbaran: "28/09/2024",
    proveedor: "PROVEEDOR 13",
    numeroAlbaran: "A013",
    unidades: 22,
    base: "2200.00",
    iva: "462.00",
    total: "2662.00",
    agente: "AGENTE 13",
  },
  {
    id: 13,
    fechaAlbaran: "29/09/2024",
    proveedor: "PROVEEDOR 14",
    numeroAlbaran: "A014",
    unidades: 19,
    base: "1900.00",
    iva: "399.00",
    total: "2299.00",
    agente: "AGENTE 14",
  },
  {
    id: 14,
    fechaAlbaran: "30/09/2024",
    proveedor: "PROVEEDOR 15",
    numeroAlbaran: "A015",
    unidades: 17,
    base: "1700.00",
    iva: "357.00",
    total: "2057.00",
    agente: "AGENTE 15",
  },
  {
    id: 15,
    fechaAlbaran: "01/10/2024",
    proveedor: "PROVEEDOR 16",
    numeroAlbaran: "A016",
    unidades: 11,
    base: "1100.00",
    iva: "231.00",
    total: "1331.00",
    agente: "AGENTE 16",
  },
  {
    id: 16,
    fechaAlbaran: "02/10/2024",
    proveedor: "PROVEEDOR 17",
    numeroAlbaran: "A017",
    unidades: 9,
    base: "900.00",
    iva: "189.00",
    total: "1089.00",
    agente: "AGENTE 17",
  },
  {
    id: 17,
    fechaAlbaran: "03/10/2024",
    proveedor: "PROVEEDOR 18",
    numeroAlbaran: "A018",
    unidades: 13,
    base: "1300.00",
    iva: "273.00",
    total: "1573.00",
    agente: "AGENTE 18",
  },
  {
    id: 18,
    fechaAlbaran: "04/10/2024",
    proveedor: "PROVEEDOR 19",
    numeroAlbaran: "A019",
    unidades: 16,
    base: "1600.00",
    iva: "336.00",
    total: "1936.00",
    agente: "AGENTE 19",
  },
  {
    id: 19,
    fechaAlbaran: "05/10/2024",
    proveedor: "PROVEEDOR 20",
    numeroAlbaran: "A020",
    unidades: 21,
    base: "2100.00",
    iva: "441.00",
    total: "2541.00",
    agente: "AGENTE 20",
  },
];

export function selectProductName(id) {
  if (id === -1) {
    return "Inserción manual";
  }
  const names = {
    0: "Audífonos",
    1: "Lentes oftálmicas",
    2: "Lentes de contacto",
    3: "Líquidos",
    4: "Monturas",
    5: "Varios",
    6: "Gafas de sol",
  };
  return names[id];
}

export const progressiveDataStructure = {
  distanciaVerticeD: "",
  distanciaVerticeI: "",
  coeficienteCabezaOjo: "",
  coeficienteEstabilidad: "",
  distanciaLectura: "",
  anguloPantoscopico: "",
  anguloGalbe: "",
  longitudProgresion: "",
  eyeCode: false,
  ojoDominante: "",
  grabadosD: "",
  grabadosI: "",
  iniciales: "",
  distanciaCROD: "",
  distanciaCROI: "",
  anguloCabeza: "",
};

export const numOptometriesStruct = {
  optometria: {
    num: 0,
    id: -1,
  },
  anamnesis: {
    num: 0,
    id: -1,
  },
  refractivo: {
    num: 0,
    id: -1,
  },
  oculomotor: {
    num: 0,
    id: -1,
  },
  binocular: {
    num: 0,
    id: -1,
  },
  acomodativo: {
    num: 0,
    id: -1,
  },
  sensorial: {
    num: 0,
    id: -1,
  },
  saludOcular: {
    num: 0,
    id: -1,
  },
  ficheros: 0,
};

export const productFamilies = [
  "AUDÍFONOS",
  "LENTES",
  "LENTES DE CONTACTO",
  "LÍQUIDOS",
  "MONTURAS",
  "VARIOS",
  "SOL",
];

export const crmChannels = ["SMS", "RCS", "WHATSAPP", "EMAIL"];

export const crmTypeList = [
  { id: "Comercial", text: "COMERCIAL" },
  { id: "Servicios", text: "SERVICIOS" },
];

export const crmChannelOptions = [
  { id: "SMS", text: "SMS" },
  { id: "RCS", text: "RCS" },
  { id: "Whatsapp", text: "WHATSAPP" },
  { id: "Email", text: "EMAIL" },
];

export const familiesList = [
  { id: 0, text: "AUDÍFONOS" },
  { id: 1, text: "LENTES" },
  { id: 2, text: "LENTES DE CONTACTO" },
  { id: 3, text: "LÍQUIDOS" },
  { id: 4, text: "MONTURAS" },
  { id: 5, text: "VARIOS" },
  { id: 6, text: "SOL" },
];

export const recordTypeOptionList = [
  { id: "Vista", text: "VISTA" },
  { id: "Sol", text: "SOL" },
  { id: "VistaSol", text: "VISTA/SOL" },
  { id: "LC", text: "LC" },
  { id: "Audifonos", text: "AUDÍFONOS" },
];

export const exportableFieldsReportType = [
  {
    id: "Codigo",
    text: "Código",
    reportType: [0, 1, 2, 3, 4],
  },
  {
    id: "EANUPC",
    text: "EAN-UPC",
    reportType: [0, 1, 2, 3, 4],
  },
  {
    id: "UltimaCompra",
    text: "Última compra",
    reportType: [0],
  },
  {
    id: "Proveedor",
    text: "Proveedor",
    reportType: [0, 1, 2, 3, 4],
  },
  {
    id: "PCN",
    text: "PCN",
    reportType: [0, 1, 2, 3, 4],
  },
  {
    id: "MCC",
    text: "MCC",
    reportType: [0, 2],
  },
  {
    id: "MCV",
    text: "MCV",
    reportType: [0, 2],
  },
  {
    id: "PVP",
    text: "PVP",
    reportType: [0, 1, 2, 3, 4],
  },
  {
    id: "Stock",
    text: "Stock",
    reportType: [0],
  },
  {
    id: "StockMinimo",
    text: "Stock mínimo",
    reportType: [0],
  },
  {
    id: "FechaCompra",
    text: "Fecha compra",
    reportType: [1, 2, 3],
  },
  {
    id: "Albaran",
    text: "Albarán",
    reportType: [1],
  },
  {
    id: "FechaAlbaran",
    text: "Fecha albarán",
    reportType: [1],
  },
  {
    id: "PCB",
    text: "PCB",
    reportType: [1, 3],
  },
  {
    id: "PorctDto",
    text: "% DTO",
    reportType: [1, 2, 3],
  },
  {
    id: "Uds",
    text: "UDS",
    reportType: [1, 2, 3, 4],
  },
  {
    id: "Beneficios",
    text: "Beneficio €",
    reportType: [2],
  },
  {
    id: "Total",
    text: "Total",
    reportType: [2],
  },
  {
    id: "FechaVenta",
    text: "Fecha venta",
    reportType: [2],
  },
  {
    id: "FechaTraspaso",
    text: "Fecha traspaso",
    reportType: [3],
  },
  {
    id: "FechaHora",
    text: "Fecha y hora",
    reportType: [4],
  },
  {
    id: "Optica",
    text: "Óptica",
    reportType: [4],
  },
  {
    id: "Motivo",
    text: "Motivo",
    reportType: [4],
  },
  {
    id: "OpticaOrigen",
    text: "Óptica Origen",
    reportType: [3],
  },
  {
    id: "OpticaDestino",
    text: "Óptica Destino",
    reportType: [3],
  },
];

export const exportableFieldsFamily = [
  {
    id: "Marca",
    text: "Marca",
    reportType: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    id: "Modelo",
    text: "Modelo",
    reportType: [0, 4, 6],
  },
  {
    id: "Nombre",
    text: "Nombre",
    reportType: [1, 2, 3],
  },
  {
    id: "Producto",
    text: "Producto",
    reportType: [5],
  },
  {
    id: "Tipo",
    text: "Tipo",
    reportType: [0, 2],
  },
  {
    id: "EntreDB",
    text: "Entre DB",
    reportType: [0],
  },
  {
    id: "HastaDB",
    text: "Hasta DB",
    reportType: [0],
  },
  {
    id: "Color",
    text: "Color",
    reportType: [1, 2, 4, 6],
  },
  {
    id: "Tratamiento",
    text: "Tratamiento",
    reportType: [1],
  },
  {
    id: "Indice",
    text: "Índice",
    reportType: [1],
  },
  {
    id: "Esfera",
    text: "Esfera",
    reportType: [1, 2],
  },
  {
    id: "Cilindro",
    text: "Cilindro",
    reportType: [1, 2],
  },
  {
    id: "Eje",
    text: "Eje",
    reportType: [1, 2],
  },
  {
    id: "Adicion",
    text: "Adición",
    reportType: [1, 2],
  },
  {
    id: "Total",
    text: "Total",
    reportType: [1, 2],
  },
  {
    id: "Uso",
    text: "Uso",
    reportType: [2],
  },
  {
    id: "Diametro",
    text: "Diámetro",
    reportType: [2],
  },
  {
    id: "Radio1",
    text: "Radio 1",
    reportType: [2],
  },
  {
    id: "Radio2",
    text: "Radio 2",
    reportType: [2],
  },
  {
    id: "Capacidad",
    text: "Capacidad",
    reportType: [3],
  },
  {
    id: "Calibre",
    text: "Calibre",
    reportType: [4, 6],
  },
  {
    id: "Puente",
    text: "Puente",
    reportType: [4, 6],
  },
  {
    id: "Varilla",
    text: "Varilla",
    reportType: [4, 6],
  },
  {
    id: "Material",
    text: "Material",
    reportType: [4, 6],
  },
  {
    id: "Forma",
    text: "Forma",
    reportType: [4, 6],
  },
  {
    id: "Genero",
    text: "Género",
    reportType: [4, 6],
  },
  {
    id: "Categoria",
    text: "Categoría",
    reportType: [5],
  },
  {
    id: "ColorCristal",
    text: "Color lente",
    reportType: [6],
  },
];

export const exportableFieldsPatient = [
  {
    id: "Codigo",
    text: "Código",
    reportType: [0],
  },
  {
    id: "Nombre",
    text: "Nombre",
    reportType: [0],
  },
  {
    id: "Apellidos",
    text: "Apellidos",
    reportType: [0],
  },
  {
    id: "CPostal",
    text: "Código postal",
    reportType: [0],
  },
  {
    id: "Direccion",
    text: "Dirección",
    reportType: [0],
  },
  {
    id: "Localidad",
    text: "Localidad",
    reportType: [0],
  },
  {
    id: "Provincia",
    text: "Provincia",
    reportType: [0],
  },
  {
    id: "Telefono",
    text: "Teléfono",
    reportType: [0],
  },
  {
    id: "Movil",
    text: "Móvil",
    reportType: [0],
  },
  {
    id: "Email",
    text: "Email",
    reportType: [0],
  },
  {
    id: "Puntos",
    text: "Puntos",
    reportType: [0],
  },
  {
    id: "FNacimiento",
    text: "Fecha nacimiento",
    reportType: [0],
  },
  {
    id: "FAlta",
    text: "Fecha de alta",
    reportType: [0],
  },
  {
    id: "UltimaVisita",
    text: "Última Visita",
    reportType: [0],
  },
];

export const dashboardStoreFilter = {
  stockPositivo: false,
  stockMinimo: false,
  fechaCompraDesde: "",
  fechaCompraHasta: "",
  fechaLimiteDesde: "",
  fechaLimiteHasta: "",
  pcnDesde: "",
  pcnHasta: "",
  pvpDesde: "",
  pvpHasta: "",
  fechaAlbaranDesde: "",
  fechaAlbaranHasta: "",
  fechaVentaDesde: "",
  fechaVentaHasta: "",
  fechaTraspasoDesde: "",
  fechaTraspasoHasta: "",
  positivos: false,
  negativos: false,
  fechaAjusteDesde: "",
  fechaAjusteHasta: "",
  motivo: "",
};

export function getDefaultExportableFields(id) {
  const fieldsById = {
    0: ["Marca", "Modelo"],
    1: ["Marca", "Nombre"],
    2: ["Marca", "Nombre"],
    3: ["Marca", "Nombre"],
    4: ["Marca", "Modelo", "Color"],
    5: ["Marca", "Producto", "Categoria"],
    6: [
      "Marca",
      "Modelo",
      "Color",
      "ColorCristal",
      "Calibre",
      "Puente",
      "Varilla",
      "Material",
      "Forma",
      "Genero",
    ],
  };

  return fieldsById[id] ?? [];
}

export const exportableFieldsSales = [
  {
    id: "NFactura",
    text: "Nº factura",
    default: true,
  },
  {
    id: "Fecha",
    text: "Fecha",
    default: true,
  },
  {
    id: "Agente",
    text: "Agente",
    default: true,
  },
  {
    id: "CodigoPaciente",
    text: "Cód. cliente",
    default: true,
  },
  {
    id: "NIF",
    text: "NIF",
    default: true,
  },
  {
    id: "Paciente",
    text: "Paciente",
    default: true,
  },
  {
    id: "BaseTotal",
    text: "Base total",
    default: true,
  },
  {
    id: "IVATotal",
    text: "IVA total",
    default: true,
  },
  {
    id: "TotalVenta",
    text: "Total venta",
    default: true,
  },
  {
    id: "DesglosarIVA",
    text: "Desglosar IVA",
    default: false,
  },
  {
    id: "CodigoPostal",
    text: "Código postal",
    default: false,
  },
  {
    id: "Telefono",
    text: "Teléfono",
    default: false,
  },
  {
    id: "Beneficio",
    text: "Beneficio",
    default: false,
  },
];

const formatterDefault = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});
const formatterEuro = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatValueUnit = (value, unit = "") => {
  // Convertir a número si viene como string
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  // Si no es un número válido, devolver el valor original con la unidad
  if (isNaN(numValue)) {
    return unit === "" ? `${value}` : `${value} ${unit}`;
  }

  const formatter = unit === "€" ? formatterEuro : formatterDefault;

  return unit === ""
    ? `${formatter.format(numValue)}`
    : `${formatter.format(numValue)} ${unit}`;
};

export const exportDataStore = {
  tipoCategoria: 0,
  familia: "",
  opticas: [],
  proveedores: [],
  marcas: [],
  filtros: {
    stockPositivo: false,
    stockMinimo: false,
    fechaCompraDesde: "",
    fechaCompraHasta: "",
    fechaLimiteDesde: "",
    fechaLimiteHasta: "",
    pcnDesde: "",
    pcnHasta: "",
    pvpDesde: "",
    pvpHasta: "",
    fechaAlbaranDesde: "",
    fechaAlbaranHasta: "",
    fechaVentaDesde: "",
    fechaVentaHasta: "",
    fechaTraspasoDesde: "",
    fechaTraspasoHasta: "",
    positivos: false,
    negativos: false,
    fechaAjusteDesde: "",
    fechaAjusteHasta: "",
    motivo: "",
  },
  camposInforme: [],
  camposFamilia: [],
  camposFamiliaTipologia: [],
  tipoSalida: {
    salida: "",
    agrupadoProveedores: false,
    agrupadoMarcas: false,
    opticas: [],
    aDia: "",
    opticasOrigen: [],
    opticasDestino: [],
  },
  tipoFichero: "",
  email: "",
};

export const exportDataPatient = {
  filtrosGenerales: {
    opticasAlta: [],
    localidades: [],
    provincias: [],
    codigosPostales: [],
    edadDesde: "",
    edadHasta: "",
    hombre: false,
    mujer: false,
    tieneHijos: false,
    tieneCarnet: false,
    usuariosDe: [],
    ametropias: [],
    aficiones: [],
    profesiones: [],
    fechaAltaDesde: "",
    fechaAltaHasta: "",
    ultimaVisitaDesde: "",
    ultimaVisitaHasta: "",
  },

  filtrosFicha: {
    tipoFicha: "",
    fechaCreacionDesde: "",
    fechaCreacionHasta: "",
    seaPrimeraCreacion: false,
    seaUltimaCreacion: false,
    fechaRevisionDesde: "",
    fechaRevisionHasta: "",
    seaPrimeraRevision: false,
    seaUltimaRevision: false,
    agentes: [],
    filtrosGafas: {
      vistaSol: 0,
      proveedoresMontura: [],
      marcasMonturas: [],
      proveedoresLentes: [],
      marcasLentes: [],
      tipoGafa: [],
      cilDesde: "",
      cilHasta: "",
      esfDesde: "",
      esfHasta: "",
      addDesde: "",
      addHasta: "",
    },

    filtrosLentesContacto: {
      proveedores: [],
      marcas: [],
      tipoLC: [],
      uso: [],
      cilDesde: "",
      cilHasta: "",
      esfDesde: "",
      esfHasta: "",
      addDesde: "",
      addHasta: "",
    },

    filtrosAudifonos: {
      proveedores: [],
      marcas: [],
      tipoAudifono: [],
    },
  },

  filtrosCompra: {
    familia: "",
    proveedores: [],
    marcas: [],
    fechaCompraDesde: "",
    fechaCompraHasta: "",
    seaUltimaCompra: "",
    volumenCompraDesde: "",
    volumenCompraHasta: "",
    noIncluirComprasDevueltas: false,
    puntosDisponiblesDesde: "",
    puntosDisponiblesHasta: "",
    conFidelizacion: false,
    sinFidelizacion: false,
  },

  datosExportacion: [],
  tipoFichero: "",
  email: "",
};

export const dashboardPatientFFOptions = {
  optometria: false,
  gafas: false,
  lc: false,
  audiometria: false,
  audifonos: false,
};

export const inventoryCategoryOptions = {
  audifonos: false,
  lentes: false,
  lc: false,
  liquidos: false,
  monturas: false,
  varios: false,
  sol: false,
};

export const dashboardPatientFFDates = {
  creationDateFrom: "",
  creationDateTo: "",
  revisionDateFrom: "",
  revisionDateTo: "",
};

export const dashboardPatientFFToggle = {
  firstCreated: false,
  lastCreated: false,
  firstRevised: false,
  lastRevised: false,
};

export const dashboardPatientGlassesModule = {
  vistaSol: 0,
  proveedoresMontura: [],
  marcasMonturas: [],
  proveedoresLentes: [],
  marcasLentes: [],
  tipoGafa: [],
  cilDesde: "",
  cilHasta: "",
  esfDesde: "",
  esfHasta: "",
  addDesde: "",
  addHasta: "",
};

export const dashboardPatientContactLensesModule = {
  proveedores: [],
  marcas: [],
  tipoLC: [],
  uso: [],
  cilDesde: "",
  cilHasta: "",
  esfDesde: "",
  esfHasta: "",
  addDesde: "",
  addHasta: "",
};

export const dashboardPatientHearingAidsModule = {
  proveedores: [],
  marcas: [],
  tipoAudifono: [],
};

export function calculateTotalLens(esf, add) {
  // Convertir a números
  const esfNum = esf === "" ? 0 : Number(esf);
  const addNum = Number(add);

  // Calcular total
  const total = esfNum + addNum;

  return total;
}

export function calculateAddFromTotal(esf, total) {
  // Si no hay total válido, retornar vacío
  if (total === "") {
    return "";
  }

  // Convertir a números (esfera por defecto 0 si no existe o está vacía)
  const esfNum = esf === "" ? 0 : Number(esf);
  const totalNum = Number(total);

  // Calcular adición: Total - Esfera
  const add = totalNum - esfNum;

  // Si la adición es negativa, retornar vacío (no es válida)
  if (add < 0) {
    return "";
  }

  return add;
}

export function calculateTransposition(esfera, totalC, totalI, cilindro, eje) {
  // ============================================
  // PASO 1: VALIDACIÓN Y VALORES POR DEFECTO
  // ============================================

  // Asignar valores por defecto si están vacíos
  esfera = esfera === "" ? "0.00" : esfera;
  cilindro = cilindro === "" ? "0.00" : cilindro;
  eje = eje === "" ? "0" : eje;

  // ============================================
  // PASO 2: CONVERSIÓN A NÚMEROS
  // ============================================

  const numEsfera = Number(esfera);
  const numCilindro = Number(cilindro);
  const numEje = parseInt(eje, 10);

  // Convertir Total_C y Total_I solo si tienen valor
  const numTotalC = totalC !== "" ? Number(totalC) : null;
  const numTotalI = totalI !== "" ? Number(totalI) : null;

  // ============================================
  // PASO 3: APLICAR FÓRMULAS DE TRANSPOSICIÓN
  // ============================================

  // Nueva esfera = Esfera + Cilindro
  const esferaT = numEsfera + numCilindro;

  // Nuevo Total_C = Total_C + Cilindro (solo si existe)
  const totalCT = numTotalC !== null ? numTotalC + numCilindro : null;

  // Nuevo Total_I = Total_I + Cilindro (solo si existe)
  const totalIT = numTotalI !== null ? numTotalI + numCilindro : null;

  // Nuevo cilindro = -Cilindro
  const cilindroT = -numCilindro;

  // Nuevo eje = Eje ± 90° (mantener en rango 0-180)
  let ejeT;
  if (numEje >= 90) {
    ejeT = numEje - 90;
  } else {
    ejeT = numEje + 90;
  }

  // ============================================
  // PASO 4: FORMATEAR CON SIGNO EXPLÍCITO
  // ============================================

  // Formatea un número con 2 decimales y signo explícito
  const formatearConSigno = (valor) => {
    const formatted = valor.toFixed(2);
    return valor >= 0 ? `+${formatted}` : formatted;
  };

  // Formatear valores obligatorios
  const esferaTFormatted = formatearConSigno(esferaT);
  const cilindroTFormatted = formatearConSigno(cilindroT);
  const ejeTFormatted = ejeT.toString();

  // Formatear valores opcionales solo si existían
  const totalCTFormatted = totalCT !== null ? formatearConSigno(totalCT) : "";
  const totalITFormatted = totalIT !== null ? formatearConSigno(totalIT) : "";

  // ============================================
  // PASO 5: RETORNAR RESULTADO
  // ============================================

  return {
    esferaT: esferaTFormatted, // Esfera transpuesta
    totalCT: totalCTFormatted, // Total_C transpuesto (puede ser vacío)
    totalIT: totalITFormatted, // Total_I transpuesto (puede ser vacío)
    cilindroT: cilindroTFormatted, // Cilindro transpuesto
    ejeT: ejeTFormatted, // Eje transpuesto
  };
}

export function validateOptometryData(optometry) {
  const requiredSections = [
    // RX NUEVA
    [
      "esfera_d",
      "esfera_i",
      "cilindro_d",
      "cilindro_i",
      "eje_d",
      "eje_i",
      "adicion_d",
      "adicion_i",
      "intermedia_d",
      "intermedia_i",
      "cerca_d",
      "cerca_i",
      "total_d",
      "total_i",
    ],
    // AV SC
    [
      "av_sc_lejos_d",
      "av_sc_lejos_i",
      "av_sc_lejos",
      "av_sc_cerca_d",
      "av_sc_cerca_i",
      "av_sc_cerca",
    ],
    // AV CC
    [
      "av_cc_lejos_d",
      "av_cc_lejos_i",
      "av_cc_lejos",
      "av_cc_cerca_d",
      "av_cc_cerca_i",
      "av_cc_cerca",
    ],
    // DIP
    [
      "nasopupilar_lejos_d",
      "nasopupilar_lejos_i",
      "interpupilar_lejos",
      "nasopupilar_cerca_d",
      "nasopupilar_cerca_i",
      "interpupilar_cerca",
    ],
    // QUERATOMETRIA
    [
      "h_od_dp",
      "h_od_mm",
      "ejedh",
      "v_od_dp",
      "v_od_mm",
      "ejedv",
      "h_oi_dp",
      "h_oi_mm",
      "ejeih",
      "v_oi_dp",
      "v_oi_mm",
      "ejeiv",
    ],
  ];

  return requiredSections.some((section) =>
    section.some(
      (field) => optometry[field] !== "" && optometry[field] != null,
    ),
  );
}

export function validateAnamnesisData(anamnesis) {
  const fieldsToCheck = [
    "sintomas_signos",
    "tipo_gafa_graduadas",
    "cristal",
    "tipo_prisma",
    "tipo_lentes_contacto",
    "marca_lentes_contacto",
    "horas_tv",
    "horas_pc",
    "horas_lectura",
    "observaciones",
    "antecedentes_familiares",
    "patologia_ocular",
    "tratamiento_patologia_ocular",
    "enfermedad_sistemica",
    "tratamiento_enfermedad_sistemica",
    "diagnostico",
  ];

  return fieldsToCheck.some((field) => {
    const value = anamnesis[field];
    return value !== "" && value !== null && value !== undefined;
  });
}

export function validateRefractiveData(refractive) {
  const fieldsToCheck = [
    "retinoscopia_esfera_od",
    "retinoscopia_cilindro_od",
    "retinoscopia_eje_od",
    "retinoscopia_esfera_oi",
    "retinoscopia_cilindro_oi",
    "retinoscopia_eje_oi",
    "tipo_retinoscopia",
    "autorrefractometria_esfera_od",
    "autorrefractometria_cilindro_od",
    "autorrefractometria_eje_od",
    "autorrefractometria_esfera_oi",
    "autorrefractometria_cilindro_oi",
    "autorrefractometria_eje_oi",
    "observaciones_refraccion_objetiva",
    "rx_nueva_esfera_od",
    "rx_nueva_cilindro_od",
    "rx_nueva_eje_od",
    "rx_nueva_add_od",
    "rx_nueva_esfera_oi",
    "rx_nueva_cilindro_oi",
    "rx_nueva_eje_oi",
    "rx_nueva_add_oi",
    "av_sc_od",
    "av_sc_oi",
    "av_sc_ao",
    "ae_od",
    "av_cc_od",
    "av_cc_oi",
    "av_cc_ao",
    "ae_oi",
    "filtros_polarizados_esfera_od",
    "filtros_polarizados_cilindro_od",
    "filtros_polarizados_eje_od",
    "filtros_polarizados_esfera_oi",
    "filtros_polarizados_cilindro_oi",
    "filtros_polarizados_eje_oi",
    "retrasado_esfera_od",
    "retrasado_cilindro_od",
    "retrasado_eje_od",
    "retrasado_esfera_oi",
    "retrasado_cilindro_oi",
    "retrasado_eje_oi",
    "control_convergencias_esfera_od",
    "control_convergencias_cilindro_od",
    "control_convergencias_eje_od",
    "control_convergencias_esfera_oi",
    "control_convergencias_cilindro_oi",
    "control_convergencias_eje_oi",
    "humphriss_esfera_od",
    "humphriss_cilindro_od",
    "humphriss_eje_od",
    "humphriss_esfera_oi",
    "humphriss_cilindro_oi",
    "humphriss_eje_oi",
    "observaciones_refraccion_subjetiva_binocular",
    "diagnostico",
  ];

  return fieldsToCheck.some((field) => {
    const value = refractive[field];
    return value !== "" && value !== null && value !== undefined;
  });
}

export function validateOculomotorData(oculomotor) {
  const fieldsToIgnore = [
    "fecha",
    "optometrista",
    "idPaciente",
    "idOculomotor",
    "fecha_actualizacion",
  ];

  return Object.keys(oculomotorStructure).some((field) => {
    if (fieldsToIgnore.includes(field)) {
      return false;
    }

    return oculomotor[field] !== oculomotorStructure[field];
  });
}

export function validateBinocularData(binocular) {
  const fieldsToIgnore = [
    "fecha",
    "optometrista",
    "idPaciente",
    "idBinocular",
    "fecha_actualizacion",
  ];

  return Object.keys(binocularStructure).some((field) => {
    if (fieldsToIgnore.includes(field)) {
      return false;
    }

    return binocular[field] !== binocularStructure[field];
  });
}

export function validateAccommodativeData(accommodative) {
  const fieldsToIgnore = [
    "fecha",
    "optometrista",
    "idPaciente",
    "idAcomodativo",
    "fecha_actualizacion",
  ];

  return Object.keys(accommodativeStructure).some((field) => {
    if (fieldsToIgnore.includes(field)) {
      return false;
    }

    return accommodative[field] !== accommodativeStructure[field];
  });
}

export function validateSensoryData(sensory) {
  const fieldsToIgnore = [
    "fecha",
    "optometrista",
    "idPaciente",
    "idSensorial",
    "fecha_actualizacion",
  ];

  return Object.keys(sensoryStructure).some((field) => {
    if (fieldsToIgnore.includes(field)) {
      return false;
    }

    return sensory[field] !== sensoryStructure[field];
  });
}

export function validateEyeHealthData(eyeHealth) {
  const fieldsToIgnore = [
    "fecha",
    "optometrista",
    "idPaciente",
    "idSaludOcular",
    "fecha_actualizacion",
  ];

  return Object.keys(eyeHealthStructure).some((field) => {
    if (fieldsToIgnore.includes(field)) {
      return false;
    }

    return eyeHealth[field] !== eyeHealthStructure[field];
  });
}

export function newRefractiveRXExists(refractiveData) {
  const defRX = [
    "rx_nueva_add_od",
    "rx_nueva_add_oi",
    "rx_nueva_cilindro_od",
    "rx_nueva_cilindro_oi",
    "rx_nueva_eje_od",
    "rx_nueva_eje_oi",
    "rx_nueva_esfera_od",
    "rx_nueva_esfera_oi",
  ];

  return defRX.some((field) => refractiveData[field] !== "");
}

export const calculateAge = (birthDate) => {
  if (!birthDate || birthDate === "") {
    return "";
  }

  const today = new Date();
  const birth = new Date(birthDate);

  if (isNaN(birth.getTime())) {
    return 0;
  }

  let age = today.getFullYear() - birth.getFullYear();
  const month = today.getMonth() - birth.getMonth();

  if (month < 0 || (month === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};

export const campaignDataStructure = {
  idCampana: -1,
  nombre: "",
  inicio: "",
  fin: "",
  canal: "SMS",
  idPlantilla: "",
  idLista: "",
  estado: "Borrador",
  fechaEnvio: "",
  enviosProgramados: [],
};

export const autoSendStructure = {
  cumpleanos: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  recordatorioCitas: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  revisionesOptometria: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  revisionesLC: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  revisionesAudiometria: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  comunicacionTrasVenta: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  comunicacionTrasVentaGafas: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  comunicacionTrasVentaLC: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  comunicacionTrasVentaAudifono: {
    total: 0,
    automatizar: false,
    horaEnvio: "",
    canal: "SMS",
    tipoAviso: 0,
    idPlantilla: "",
    nombrePlantilla: "",
    fechaUltimoEnvio: "",
  },

  saldoSMS: 0,
  saldoRCS: 0,
  remitente: "",
};

export const listCRMStructure = {
  nombreLista: "",
  descripcion: "",
  tipo: "Comercial",
  canal: "SMS",
  filtrosGenerales: exportDataPatient.filtrosGenerales,
  filtrosFicha: exportDataPatient.filtrosFicha,
  filtrosCompra: exportDataPatient.filtrosCompra,
};

export const invoicesSearchStructure = {
  proveedores: [],
  nFactura: "",
  fechaDesde: "",
  fechaHasta: "",
  pendiente: false,
  pagado: false,
  start: 0,
  total: 25,
};

export const invoiceStructure = {
  idFacturaAlbaran: -1,
  idProveedor: "",
  nFactura: "",
  fechaFactura: "",
  formaPago: "",
  nTarjetaIBAN: "",
  base: 0,
  iva: 0,
  total: 0,
  abonado: 0,
  pendiente: 0,
  pagada: "",
  albaranes: [],
  vencimientos: [],
};

export const hearingAidsStoreTableHeader = [
  { titulo: "Código", tipo: "string" },
  { titulo: "Últ. compra", tipo: "string" },
  { titulo: "Modelo", tipo: "string" },
  { titulo: "Tipo", tipo: "string" },
  { titulo: "Entre dB", tipo: "int" },
  { titulo: "Hasta dB", tipo: "int" },
  { titulo: "PVP", tipo: "currency" },
  { titulo: "Stock", tipo: "int" },
];

export const lensesStoreTableHeader = [
  { titulo: "Código", tipo: "string" },
  { titulo: "Últ. compra", tipo: "string" },
  { titulo: "Nombre comercial", tipo: "string" },
  { titulo: "Color", tipo: "string" },
  { titulo: "Tratamiento", tipo: "string" },
  { titulo: "Índ", tipo: "float" },
  { titulo: "Esf", tipo: "float" },
  { titulo: "Cil", tipo: "float" },
  { titulo: "Eje", tipo: "int" },
  { titulo: "Material", tipo: "string" },
  { titulo: "Tipo", tipo: "string" },
  { titulo: "PVP", tipo: "currency" },
  { titulo: "Stock", tipo: "int" },
];

export const contactLensesStoreTableHeader = [
  { titulo: "Código", tipo: "string" },
  { titulo: "Últ. compra", tipo: "string" },
  { titulo: "Nombre comercial", tipo: "string" },
  { titulo: "Tipo", tipo: "string" },
  { titulo: "Uso", tipo: "string" },
  { titulo: "Color", tipo: "string" },
  { titulo: "Esf", tipo: "float" },
  { titulo: "Cil", tipo: "float" },
  { titulo: "Eje", tipo: "int" },
  { titulo: "Rad1", tipo: "string" },
  { titulo: "Rad2", tipo: "string" },
  { titulo: "Diá", tipo: "float" },
  { titulo: "PVP", tipo: "currency" },
  { titulo: "Stock", tipo: "int" },
];

export const liquidsStoreTableHeader = [
  { titulo: "Código", tipo: "string" },
  { titulo: "Últ. compra", tipo: "string" },
  { titulo: "Marca", tipo: "string" },
  { titulo: "Nombre comercial", tipo: "string" },
  { titulo: "Capacidad (ml)", tipo: "int" },
  { titulo: "PVP", tipo: "currency" },
  { titulo: "Stock", tipo: "int" },
];

export const framesStoreTableHeader = [
  { titulo: "Código", tipo: "string" },
  { titulo: "Últ. compra", tipo: "string" },
  { titulo: "Marca", tipo: "string" },
  { titulo: "Modelo", tipo: "string" },
  { titulo: "Color", tipo: "string" },
  { titulo: "Calibre", tipo: "int" },
  { titulo: "Puente", tipo: "int" },
  { titulo: "Varilla", tipo: "int" },
  { titulo: "Material", tipo: "string" },
  { titulo: "Forma", tipo: "string" },
  { titulo: "PVP", tipo: "currency" },
  { titulo: "Stock", tipo: "int" },
];

export const variousStoreTableHeader = [
  { titulo: "Código", tipo: "string" },
  { titulo: "Últ. compra", tipo: "string" },
  { titulo: "Marca", tipo: "string" },
  { titulo: "Producto", tipo: "string" },
  { titulo: "Categoría", tipo: "string" },
  { titulo: "PVP", tipo: "currency" },
  { titulo: "Stock", tipo: "int" },
];

export const sunglassesStoreTableHeader = [
  { titulo: "Código", tipo: "string" },
  { titulo: "Últ. compra", tipo: "string" },
  { titulo: "Marca", tipo: "string" },
  { titulo: "Modelo", tipo: "string" },
  { titulo: "Color montura", tipo: "string" },
  { titulo: "Color lente", tipo: "string" },
  { titulo: "Calibre", tipo: "int" },
  { titulo: "Puente", tipo: "int" },
  { titulo: "Varilla", tipo: "int" },
  { titulo: "Material", tipo: "string" },
  { titulo: "Forma", tipo: "string" },
  { titulo: "PVP", tipo: "currency" },
  { titulo: "Stock", tipo: "int" },
];

export const goDexPrintFormatTypes = [
  {
    id: "type1",
    text: "ESTÁNDAR (RECTANGULAR)",
    labelFormat: 0,
  },
  {
    id: "type2",
    text: "DESCRIPTIVO (RECTANGULAR)",
    labelFormat: 0,
  },
  {
    id: "type3",
    text: "PVP OFERTA (RECTANGULAR)",
    labelFormat: 0,
  },
  {
    id: "type7",
    text: "PVP RECOMENDADO (RECTANGULAR)",
    labelFormat: 0,
  },
  {
    id: "type4",
    text: "ESTÁNDAR (COLGANTE)",
    labelFormat: 1,
  },
  {
    id: "type5",
    text: "DESCRIPTIVO (COLGANTE)",
    labelFormat: 1,
  },
  {
    id: "type6",
    text: "PVP OFERTA (COLGANTE)",
    labelFormat: 1,
  },
  {
    id: "type8",
    text: "PVP RECOMENDADO (COLGANTE)",
    labelFormat: 1,
  },
];

export const orderStatusList = [
  { id: "", text: "" },
  { id: "Pendiente", text: "PENDIENTE" },
  { id: "Pedido", text: "PEDIDO" },
  { id: "Recibido", text: "RECIBIDO" },
  { id: "Taller", text: "TALLER" },
  { id: "Finalizado", text: "FINALIZADO" },
];

export const hearingAidsOrderStructure = {
  idPedido: -1,
  codigo: "",
  proveedor: "",
  marca: "",
  modelo: "",
  tipo: "",
  entreDB: "",
  hastaDB: "",
  nSerie: "",
  refProveedor: "",
  fechaPedido: "",
  fechaRecepcion: "",
  estado: "",
  unidades: 1,
};

export const lensesOrderStructure = {
  idPedido: -1,
  codigo: "",
  proveedor: "",
  marca: "",
  nombreComercial: "",
  tipo: "",
  color: "",
  material: "",
  ojo: "DER",
  tratamiento: "",
  refProveedor: "",
  ind: "",
  esf: "",
  cil: "",
  eje: "",
  add: "",
  total: "",
  dia: "",
  den: "",
  abbe: "",
  fechaPedido: "",
  fechaRecepcion: "",
  estado: "",
  unidades: 1,
  pedidoAutomatizado: false,
  idPedidoAutomatizado: "",
  urlPedidoAutomatizado: "",
};

export const contactLensesOrderStructure = {
  idPedido: -1,
  codigo: "",
  proveedor: "",
  marca: "",
  nombreComercial: "",
  tipo: "",
  color: "",
  desechable: false,
  unidadesCaja: "",
  uso: "",
  refProveedor: "",
  esf: "",
  cil: "",
  eje: "",
  add: "",
  total: "",
  rad1: "",
  rad2: "",
  dia: "",
  hid: "",
  zo: "",
  ela: "",
  fechaPedido: "",
  fechaRecepcion: "",
  estado: "",
  unidades: 1,
};

export const liquidOrderStructure = {
  idPedido: -1,
  codigo: "",
  proveedor: "",
  marca: "",
  nombreComercial: "",
  capacidad: "",
  refProveedor: "",
  fechaPedido: "",
  fechaRecepcion: "",
  estado: "",
  unidades: 1,
};

export const frameOrderStructure = {
  idPedido: -1,
  codigo: "",
  proveedor: "",
  marca: "",
  modelo: "",
  genero: "",
  color: "",
  calibre: "",
  puente: "",
  material: "",
  varilla: "",
  forma: "",
  refProveedor: "",
  fechaPedido: "",
  fechaRecepcion: "",
  estado: "",
  unidades: 1,
};

export const variousOrderStructure = {
  idPedido: -1,
  codigo: "",
  proveedor: "",
  marca: "",
  producto: "",
  subtipo: "",
  refProveedor: "",
  fechaPedido: "",
  fechaRecepcion: "",
  estado: "",
  unidades: 1,
};

export const sunglassesOrderStructure = {
  idPedido: -1,
  codigo: "",
  proveedor: "",
  marca: "",
  modelo: "",
  genero: "",
  color: "",
  calibre: "",
  puente: "",
  colorCristal: "",
  material: "",
  varilla: "",
  forma: "",
  refProveedor: "",
  fechaPedido: "",
  fechaRecepcion: "",
  estado: "",
  unidades: 1,
};

export const inventoryDataStruct = {
  idInventario: "",
  productosLeidos: "",
  stockTotal: "",
  productos: [],
};

export const inventoryInfoStruct = [
  {
    familia: 0,
    fecha: "",
  },
  {
    familia: 1,
    fecha: "",
  },
  {
    familia: 2,
    fecha: "",
  },
  {
    familia: 3,
    fecha: "",
  },
  {
    familia: 4,
    fecha: "",
  },
  {
    familia: 5,
    fecha: "",
  },
  {
    familia: 6,
    fecha: "",
  },
];
